var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 56,
    viewBox: "0 0 94 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.7657 41.3721L44.9477 46.4318C45.9883 46.9046 47.1898 46.9046 48.2304 46.4318L59.384 41.3721L60.1598 38.1472L46.5843 40.8898L33.2266 39.1308L33.7657 41.3721Z",
    fill: "url(#paint0_radial_578_447519)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3352 27.7062L60.7837 34.1466L59.9323 39.2251L48.2111 44.4361C47.1799 44.8995 46.0069 44.8995 44.9757 44.4361L33.2545 39.2251L32.4504 34.3547L30.8516 27.6968L36.225 30.0989L38.2589 33.8062L44.7392 36.3974L45.7893 37.8538L46.5934 38.9792L47.4164 37.8255L48.4476 36.388L54.9279 33.7967L56.9618 30.0894L62.3352 27.7062Z",
    fill: "url(#paint1_radial_578_447519)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2941 37.0489C55.2731 37.0801 55.2732 37.1208 55.2942 37.152C55.4935 37.448 55.7166 37.7318 55.9575 37.9975C55.971 38.0109 55.9844 38.031 56.0045 38.0444C56.0783 38.1247 56.1588 38.2051 56.2393 38.2854C56.4272 38.4729 56.615 38.6469 56.823 38.8076C57.0019 38.9553 57.1864 39.0917 57.3818 39.222C57.4131 39.2428 57.4538 39.2428 57.4847 39.2214C57.8091 38.9965 58.3013 38.5767 58.7157 38.157C59.0756 37.7924 59.4433 37.3066 59.5615 37.147C59.5852 37.115 59.5855 37.072 59.5626 37.0394C59.4892 36.9348 59.3263 36.7048 59.2249 36.5783C59.037 36.344 58.8357 36.1163 58.6278 35.9021C58.5137 35.7883 58.3997 35.6812 58.2789 35.5741C58.0264 35.3536 57.762 35.1509 57.4857 34.9604C57.4542 34.9387 57.4127 34.9385 57.381 34.9598C57.1782 35.0965 56.9815 35.2392 56.7962 35.3933C56.6016 35.554 56.4205 35.7214 56.246 35.8954C55.8855 36.2616 55.5681 36.6402 55.2941 37.0489Z",
    fill: "#EAF7FA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2941 37.0489C55.2731 37.0801 55.2732 37.1208 55.2942 37.152C55.4935 37.448 55.7166 37.7318 55.9575 37.9975C55.971 38.0109 55.9844 38.031 56.0045 38.0444C56.0783 38.1247 56.1588 38.2051 56.2393 38.2854C56.4272 38.4729 56.615 38.6469 56.823 38.8076C57.0019 38.9553 57.1864 39.0917 57.3818 39.222C57.4131 39.2428 57.4538 39.2428 57.4847 39.2214C57.8091 38.9965 58.3013 38.5767 58.7157 38.157C59.0756 37.7924 59.4433 37.3066 59.5615 37.147C59.5852 37.115 59.5855 37.072 59.5626 37.0394C59.4892 36.9348 59.3263 36.7048 59.2249 36.5783C59.037 36.344 58.8357 36.1163 58.6278 35.9021C58.5137 35.7883 58.3997 35.6812 58.2789 35.5741C58.0264 35.3536 57.762 35.1509 57.4857 34.9604C57.4542 34.9387 57.4127 34.9385 57.381 34.9598C57.1782 35.0965 56.9815 35.2392 56.7962 35.3933C56.6016 35.554 56.4205 35.7214 56.246 35.8954C55.8855 36.2616 55.5681 36.6402 55.2941 37.0489Z",
    fill: "#00386A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8159 37.098C55.9708 37.3325 56.1457 37.557 56.3356 37.7665C56.3456 37.7765 56.3556 37.7915 56.3706 37.8015C56.4255 37.8613 56.4855 37.9212 56.5454 37.981C56.6854 38.1207 56.8253 38.2504 56.9802 38.3702C57.1251 38.4899 57.275 38.5997 57.4349 38.7044C57.6747 38.5448 57.8996 38.3702 58.1144 38.1806C58.4592 37.8713 58.764 37.5221 59.0238 37.133C59.0338 37.118 59.0438 37.108 59.0488 37.093C58.9589 36.9633 58.8689 36.8336 58.769 36.7089C58.6291 36.5343 58.4792 36.3647 58.3243 36.205C58.2394 36.1202 58.1544 36.0404 58.0645 35.9606C57.8646 35.786 57.6547 35.6263 57.4349 35.4767C57.27 35.5864 57.1101 35.7012 56.9602 35.8259C56.8153 35.9456 56.6804 36.0703 56.5504 36.2001C56.2706 36.4844 56.0258 36.7788 55.8159 37.098Z",
    fill: "url(#paint2_radial_578_447519)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8157 37.0983H57.4297V35.4919C57.1099 35.7015 56.8101 35.9459 56.5403 36.2153C56.2704 36.4847 56.0256 36.779 55.8157 37.0983Z",
    fill: "url(#paint3_radial_578_447519)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.43 35.4919V37.1033H59.0439C58.8341 36.784 58.5892 36.4847 58.3194 36.2153C58.0446 35.9459 57.7498 35.7015 57.43 35.4919Z",
    fill: "url(#paint4_radial_578_447519)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.43 37.0984V38.7098C58.0696 38.2857 58.6192 37.737 59.0439 37.0984H57.43Z",
    fill: "url(#paint5_radial_578_447519)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8157 37.0984C56.0256 37.4177 56.2704 37.717 56.5403 37.9864C56.8101 38.2558 57.1099 38.5002 57.4297 38.7098V37.0984H55.8157Z",
    fill: "url(#paint6_radial_578_447519)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8161 37.0981C56.026 37.4174 56.2708 37.7167 56.5407 37.9861C56.8105 38.2555 57.1103 38.5 57.4301 38.7095C57.6699 38.5498 57.7549 38.495 57.9697 38.3054L56.9554 35.8409C56.8105 35.9607 56.6756 36.0854 56.5456 36.2151C56.2708 36.4845 56.026 36.7788 55.8161 37.0981Z",
    fill: "url(#paint7_radial_578_447519)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3653 37.8062C56.4202 37.8661 56.4802 37.9259 56.5402 37.9858C56.81 38.2552 57.1098 38.4996 57.4296 38.7092C57.6694 38.5495 57.8943 38.3749 58.1091 38.1853C58.4539 37.876 58.7587 37.5268 59.0186 37.1377C58.344 37.3372 57.3546 37.6116 56.3653 37.8062Z",
    fill: "url(#paint8_radial_578_447519)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3354 37.7667C56.3454 37.7766 56.3554 37.7916 56.3704 37.8016C56.4253 37.8614 56.4853 37.9213 56.5453 37.9812C56.6852 38.1209 56.8251 38.2506 56.98 38.3703C57.3597 37.6968 57.7795 36.8886 57.8145 36.5743C57.8095 36.5793 56.97 37.2728 56.3354 37.7667Z",
    fill: "url(#paint9_radial_578_447519)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4295 37.0983L58.7637 36.7141C58.6238 36.5395 58.4739 36.3699 58.319 36.2103C58.234 36.1255 58.1491 36.0456 58.0591 35.9658L57.4295 37.0983Z",
    fill: "url(#paint10_radial_578_447519)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4298 38.1612C57.8496 37.8819 58.2143 37.5227 58.4941 37.0986C58.2143 36.6796 57.8546 36.3154 57.4298 36.036C57.0101 36.3154 56.6453 36.6746 56.3655 37.0986C56.6453 37.5227 57.0051 37.8819 57.4298 38.1612Z",
    fill: "url(#paint11_radial_578_447519)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7641 36.7887C58.6242 36.6141 58.4743 36.4445 58.3194 36.2849C58.2345 36.2001 58.1495 36.1202 58.0596 36.0404C57.8597 35.8658 57.6498 35.7062 57.43 35.5565C57.2651 35.6663 57.1052 35.781 56.9553 35.9057C56.8104 36.0254 56.6755 36.1502 56.5456 36.2799C56.2857 36.5393 56.0509 36.8237 55.846 37.128C55.836 37.113 55.831 37.103 55.821 37.0881C56.0309 36.7688 56.2757 36.4694 56.5456 36.2001C56.6755 36.0703 56.8154 35.9456 56.9553 35.8259C57.1052 35.7012 57.2651 35.5814 57.43 35.4767C57.6498 35.6214 57.8597 35.786 58.0596 35.9606C58.1495 36.0404 58.2345 36.1202 58.3194 36.205C58.4793 36.3647 58.6292 36.5293 58.7641 36.7089C58.8641 36.8336 58.954 36.9633 59.0439 37.093C59.034 37.108 59.029 37.118 59.019 37.133C58.934 37.0182 58.8491 36.9035 58.7641 36.7887Z",
    fill: "url(#paint12_radial_578_447519)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3356 37.6919C56.3456 37.7019 56.3556 37.7169 56.3706 37.7268C56.4255 37.7867 56.4855 37.8466 56.5454 37.9064C56.6854 38.0461 56.8253 38.1758 56.9802 38.2956C57.1251 38.4153 57.275 38.525 57.4349 38.6298C57.6747 38.4702 57.8996 38.2956 58.1144 38.106C58.4592 37.7967 58.764 37.4475 59.0238 37.0583C59.0338 37.0733 59.0438 37.0833 59.0488 37.0983C59.0388 37.1132 59.0288 37.1232 59.0238 37.1382C58.764 37.5223 58.4592 37.8715 58.1144 38.1858C57.9046 38.3754 57.6747 38.555 57.4349 38.7096C57.28 38.6049 57.1251 38.4951 56.9802 38.3754C56.8303 38.2507 56.6854 38.121 56.5454 37.9863C56.4855 37.9264 56.4305 37.8665 56.3706 37.8067C56.3606 37.7967 56.3506 37.7817 56.3356 37.7717C56.1457 37.5622 55.9758 37.3377 55.8159 37.1032C55.8259 37.0883 55.8359 37.0783 55.8409 37.0633C55.9908 37.2828 56.1557 37.4924 56.3356 37.6919Z",
    fill: "url(#paint13_radial_578_447519)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3191 36.2849C58.474 36.4445 58.6239 36.6141 58.7638 36.7887L58.995 37.101C58.7416 37.473 58.4465 37.808 58.1144 38.1059C57.8996 38.2955 57.6747 38.4701 57.4349 38.6298C57.275 38.525 57.1251 38.4152 56.9802 38.2955C56.8253 38.1758 56.6854 38.0461 56.5454 37.9064C56.4855 37.8465 56.4255 37.7867 56.3706 37.7268C56.3603 37.72 56.3524 37.7108 56.3452 37.7025C56.3419 37.6987 56.3387 37.695 56.3356 37.6919C56.1654 37.5031 56.0087 37.3055 55.8654 37.0989C56.0656 36.8055 56.2937 36.531 56.5452 36.2799C56.6752 36.1502 56.8101 36.0254 56.955 35.9057C57.1049 35.781 57.2648 35.6663 57.4297 35.5565C57.6495 35.7062 57.8594 35.8658 58.0593 36.0404C58.1492 36.1202 58.2342 36.2001 58.3191 36.2849ZM55.8236 37.0924C55.8227 37.091 55.8217 37.0896 55.8207 37.0881C56.0306 36.7688 56.2754 36.4694 56.5452 36.2001C56.6752 36.0703 56.8151 35.9456 56.955 35.8259C57.1049 35.7012 57.2648 35.5814 57.4297 35.4767C57.6495 35.6214 57.8594 35.786 58.0593 35.9606C58.1492 36.0404 58.2342 36.1202 58.3191 36.205C58.479 36.3647 58.6289 36.5293 58.7638 36.7089C58.8556 36.8235 58.939 36.9423 59.0217 37.0615C59.0224 37.0604 59.0231 37.0594 59.0238 37.0583C59.0268 37.0628 59.0298 37.0668 59.0327 37.0706C59.0394 37.0797 59.0453 37.0877 59.0488 37.0982C59.0458 37.1027 59.0429 37.1067 59.04 37.1105C59.0333 37.1196 59.0273 37.1276 59.0238 37.1381C58.764 37.5223 58.4592 37.8715 58.1144 38.1858C57.9046 38.3753 57.6747 38.5549 57.4349 38.7096C57.28 38.6048 57.1251 38.4951 56.9802 38.3753C56.8303 38.2506 56.6854 38.1209 56.5454 37.9862C56.5155 37.9563 56.4867 37.9263 56.458 37.8964C56.4293 37.8665 56.4005 37.8365 56.3706 37.8066C56.3674 37.8035 56.3642 37.7998 56.3609 37.796C56.3537 37.7877 56.3458 37.7785 56.3356 37.7717C56.1457 37.5622 55.9758 37.3377 55.8159 37.1032C55.8185 37.0993 55.8211 37.0958 55.8236 37.0924Z",
    fill: "url(#paint14_radial_578_447519)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4297 36.04C57.4297 36.04 56.8001 36.4342 56.3654 37.1026C56.3654 37.0977 56.6752 36.4092 57.4297 36.04Z",
    fill: "url(#paint15_radial_578_447519)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M58.4893 37.0986C58.4893 37.0986 58.1145 37.7571 57.4799 38.1513L57.4299 38.6302L57.395 38.1413C57.395 38.1413 56.9203 37.9417 56.3656 37.0986C56.3656 37.0986 57.0652 38.0365 57.4399 38.0864C57.4399 38.0914 57.8747 37.9218 58.4893 37.0986Z",
    fill: "url(#paint16_radial_578_447519)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4248 38.1562C57.4248 38.1562 56.7652 37.7821 56.3705 37.1485L55.8908 37.0986L56.3805 37.0637C56.3805 37.0637 56.5804 36.5898 57.4248 36.036C57.4248 36.036 56.4854 36.7344 56.4354 37.1086C56.4304 37.1086 56.6003 37.5426 57.4248 38.1562Z",
    fill: "url(#paint17_radial_578_447519)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4494 36.036C57.4494 36.036 58.109 36.4102 58.5037 37.0437L58.9834 37.0936L58.4937 37.1286C58.4937 37.1286 58.2938 37.6025 57.4494 38.1562C57.4494 38.1562 58.3888 37.4578 58.4388 37.0837C58.4437 37.0837 58.2739 36.6496 57.4494 36.036Z",
    fill: "url(#paint18_radial_578_447519)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3656 37.0928C56.3656 37.0928 56.7404 36.4343 57.375 36.0402L57.4249 35.5613L57.4599 36.0502C57.4599 36.0502 57.9346 36.2497 58.4893 37.0928C58.4893 37.0928 57.7897 36.1549 57.415 36.1051C57.415 36.1001 56.9802 36.2697 56.3656 37.0928Z",
    fill: "url(#paint19_radial_578_447519)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9982 39.5605C49.9772 39.5917 49.9773 39.6324 49.9983 39.6636C50.1976 39.9596 50.4207 40.2434 50.6617 40.5091C50.6751 40.5225 50.6885 40.5426 50.7086 40.556C50.7824 40.6363 50.8629 40.7167 50.9434 40.797C51.1313 40.9845 51.3191 41.1585 51.5271 41.3192C51.706 41.4669 51.8905 41.6033 52.0859 41.7336C52.1172 41.7544 52.1579 41.7544 52.1888 41.733C52.5132 41.5081 53.0054 41.0883 53.4198 40.6686C53.7797 40.3039 54.1474 39.8182 54.2656 39.6586C54.2893 39.6266 54.2896 39.5836 54.2667 39.551C54.1933 39.4464 54.0304 39.2164 53.929 39.0899C53.7411 38.8556 53.5399 38.6279 53.3319 38.4137C53.2178 38.2999 53.1038 38.1928 52.983 38.0857C52.7305 37.8652 52.4661 37.6625 52.1898 37.472C52.1583 37.4503 52.1168 37.4501 52.0851 37.4714C51.8823 37.6081 51.6856 37.7508 51.5003 37.9049C51.3057 38.0656 51.1246 38.2329 50.9501 38.407C50.5896 38.7732 50.2722 39.1518 49.9982 39.5605Z",
    fill: "#EAF7FA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M49.9982 39.5605C49.9772 39.5917 49.9773 39.6324 49.9983 39.6636C50.1976 39.9596 50.4207 40.2434 50.6617 40.5091C50.6751 40.5225 50.6885 40.5426 50.7086 40.556C50.7824 40.6363 50.8629 40.7167 50.9434 40.797C51.1313 40.9845 51.3191 41.1585 51.5271 41.3192C51.706 41.4669 51.8905 41.6033 52.0859 41.7336C52.1172 41.7544 52.1579 41.7544 52.1888 41.733C52.5132 41.5081 53.0054 41.0883 53.4198 40.6686C53.7797 40.3039 54.1474 39.8182 54.2656 39.6586C54.2893 39.6266 54.2896 39.5836 54.2667 39.551C54.1933 39.4464 54.0304 39.2164 53.929 39.0899C53.7411 38.8556 53.5399 38.6279 53.3319 38.4137C53.2178 38.2999 53.1038 38.1928 52.983 38.0857C52.7305 37.8652 52.4661 37.6625 52.1898 37.472C52.1583 37.4503 52.1168 37.4501 52.0851 37.4714C51.8823 37.6081 51.6856 37.7508 51.5003 37.9049C51.3057 38.0656 51.1246 38.2329 50.9501 38.407C50.5896 38.7732 50.2722 39.1518 49.9982 39.5605Z",
    fill: "#00386A"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M50.52 39.6096C50.6749 39.8441 50.8498 40.0686 51.0397 40.2781C51.0497 40.2881 51.0597 40.3031 51.0747 40.313C51.1296 40.3729 51.1896 40.4328 51.2495 40.4926C51.3895 40.6323 51.5294 40.762 51.6843 40.8818C51.8292 41.0015 51.9791 41.1113 52.139 41.216C52.3788 41.0564 52.6037 40.8818 52.8185 40.6922C53.1633 40.3829 53.4681 40.0337 53.7279 39.6446C53.7379 39.6296 53.7479 39.6196 53.7529 39.6046C53.663 39.4749 53.573 39.3452 53.4731 39.2205C53.3332 39.0459 53.1833 38.8763 53.0284 38.7166C52.9435 38.6318 52.8585 38.552 52.7686 38.4722C52.5687 38.2976 52.3588 38.1379 52.139 37.9883C51.9741 38.098 51.8142 38.2128 51.6643 38.3375C51.5194 38.4572 51.3845 38.5819 51.2545 38.7117C50.9747 38.996 50.7299 39.2904 50.52 39.6096Z",
    fill: "url(#paint20_radial_578_447519)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5198 39.6099H52.1338V38.0035C51.814 38.2131 51.5142 38.4575 51.2444 38.7269C50.9745 38.9963 50.7297 39.2906 50.5198 39.6099Z",
    fill: "url(#paint21_radial_578_447519)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1341 38.0035V39.6149H53.748C53.5382 39.2956 53.2933 38.9963 53.0235 38.7269C52.7487 38.4575 52.4539 38.2131 52.1341 38.0035Z",
    fill: "url(#paint22_radial_578_447519)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1341 39.61V41.2214C52.7737 40.7973 53.3233 40.2485 53.748 39.61H52.1341Z",
    fill: "url(#paint23_radial_578_447519)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5198 39.61C50.7297 39.9293 50.9745 40.2286 51.2444 40.498C51.5142 40.7674 51.814 41.0118 52.1338 41.2214V39.61H50.5198Z",
    fill: "url(#paint24_radial_578_447519)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5202 39.6097C50.7301 39.929 50.9749 40.2283 51.2448 40.4977C51.5146 40.7671 51.8144 41.0116 52.1342 41.2211C52.374 41.0614 52.459 41.0066 52.6738 40.817L51.6595 38.3525C51.5146 38.4723 51.3797 38.597 51.2497 38.7267C50.9749 38.9961 50.7301 39.2904 50.5202 39.6097Z",
    fill: "url(#paint25_radial_578_447519)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0694 40.3178C51.1243 40.3777 51.1843 40.4375 51.2443 40.4974C51.5141 40.7668 51.8139 41.0112 52.1337 41.2208C52.3735 41.0611 52.5984 40.8865 52.8132 40.6969C53.158 40.3876 53.4628 40.0384 53.7227 39.6493C53.0481 39.8488 52.0587 40.1232 51.0694 40.3178Z",
    fill: "url(#paint26_radial_578_447519)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0395 40.2783C51.0495 40.2882 51.0595 40.3032 51.0745 40.3132C51.1295 40.373 51.1894 40.4329 51.2494 40.4928C51.3893 40.6325 51.5292 40.7622 51.6841 40.8819C52.0638 40.2084 52.4836 39.4002 52.5186 39.0859C52.5136 39.0909 51.6741 39.7844 51.0395 40.2783Z",
    fill: "url(#paint27_radial_578_447519)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1336 39.6099L53.4678 39.2257C53.3279 39.0511 53.178 38.8815 53.0231 38.7219C52.9381 38.6371 52.8532 38.5572 52.7632 38.4774L52.1336 39.6099Z",
    fill: "url(#paint28_radial_578_447519)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1339 40.6728C52.5537 40.3935 52.9184 40.0343 53.1982 39.6102C52.9184 39.1912 52.5587 38.827 52.1339 38.5476C51.7142 38.827 51.3494 39.1862 51.0696 39.6102C51.3494 40.0343 51.7092 40.3935 52.1339 40.6728Z",
    fill: "url(#paint29_radial_578_447519)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4682 39.3003C53.3283 39.1257 53.1784 38.9561 53.0235 38.7965C52.9386 38.7117 52.8536 38.6318 52.7637 38.552C52.5638 38.3774 52.3539 38.2178 52.1341 38.0681C51.9692 38.1779 51.8093 38.2926 51.6594 38.4173C51.5145 38.537 51.3796 38.6618 51.2497 38.7915C50.9898 39.0509 50.755 39.3352 50.5501 39.6396C50.5401 39.6246 50.5351 39.6146 50.5251 39.5997C50.735 39.2804 50.9798 38.981 51.2497 38.7117C51.3796 38.5819 51.5195 38.4572 51.6594 38.3375C51.8093 38.2128 51.9692 38.093 52.1341 37.9883C52.3539 38.133 52.5638 38.2976 52.7637 38.4722C52.8536 38.552 52.9386 38.6318 53.0235 38.7166C53.1834 38.8763 53.3333 39.0409 53.4682 39.2205C53.5682 39.3452 53.6581 39.4749 53.748 39.6046C53.7381 39.6196 53.7331 39.6296 53.7231 39.6446C53.6381 39.5298 53.5532 39.4151 53.4682 39.3003Z",
    fill: "url(#paint30_radial_578_447519)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0397 40.2035C51.0497 40.2135 51.0597 40.2285 51.0747 40.2384C51.1296 40.2983 51.1896 40.3582 51.2495 40.418C51.3895 40.5577 51.5294 40.6874 51.6843 40.8072C51.8292 40.9269 51.9791 41.0366 52.139 41.1414C52.3788 40.9818 52.6037 40.8072 52.8185 40.6176C53.1633 40.3083 53.4681 39.9591 53.7279 39.5699C53.7379 39.5849 53.7479 39.5949 53.7529 39.6099C53.7429 39.6248 53.7329 39.6348 53.7279 39.6498C53.4681 40.0339 53.1633 40.3831 52.8185 40.6974C52.6087 40.887 52.3788 41.0666 52.139 41.2212C51.9841 41.1165 51.8292 41.0067 51.6843 40.887C51.5344 40.7623 51.3895 40.6326 51.2495 40.4979C51.1896 40.438 51.1346 40.3781 51.0747 40.3183C51.0647 40.3083 51.0547 40.2933 51.0397 40.2833C50.8498 40.0738 50.6799 39.8493 50.52 39.6148C50.53 39.5999 50.54 39.5899 50.545 39.5749C50.6949 39.7944 50.8598 40.004 51.0397 40.2035Z",
    fill: "url(#paint31_radial_578_447519)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.0232 38.7965C53.1781 38.9561 53.328 39.1257 53.4679 39.3003L53.6991 39.6126C53.4457 39.9846 53.1506 40.3196 52.8185 40.6175C52.6037 40.8071 52.3788 40.9817 52.139 41.1414C51.9791 41.0366 51.8292 40.9268 51.6843 40.8071C51.5294 40.6874 51.3895 40.5577 51.2495 40.418C51.1896 40.3581 51.1296 40.2983 51.0747 40.2384C51.0644 40.2316 51.0565 40.2224 51.0493 40.2141C51.046 40.2103 51.0428 40.2066 51.0397 40.2035C50.8695 40.0147 50.7128 39.8171 50.5695 39.6105C50.7697 39.3171 50.9978 39.0426 51.2493 38.7915C51.3793 38.6618 51.5142 38.537 51.6591 38.4173C51.809 38.2926 51.9689 38.1779 52.1338 38.0681C52.3536 38.2178 52.5635 38.3774 52.7634 38.552C52.8533 38.6318 52.9383 38.7117 53.0232 38.7965ZM50.5277 39.604C50.5268 39.6026 50.5258 39.6012 50.5248 39.5997C50.7347 39.2804 50.9795 38.981 51.2493 38.7117C51.3793 38.5819 51.5192 38.4572 51.6591 38.3375C51.809 38.2128 51.9689 38.093 52.1338 37.9883C52.3536 38.133 52.5635 38.2976 52.7634 38.4722C52.8533 38.552 52.9383 38.6318 53.0232 38.7166C53.1831 38.8763 53.333 39.0409 53.4679 39.2205C53.5597 39.3351 53.6431 39.4539 53.7258 39.5731C53.7265 39.572 53.7272 39.5709 53.7279 39.5699C53.7309 39.5744 53.7339 39.5784 53.7368 39.5822C53.7435 39.5913 53.7494 39.5993 53.7529 39.6098C53.7499 39.6143 53.747 39.6183 53.7441 39.6221C53.7374 39.6312 53.7315 39.6392 53.7279 39.6497C53.4681 40.0338 53.1633 40.3831 52.8185 40.6974C52.6087 40.8869 52.3788 41.0665 52.139 41.2212C51.9841 41.1164 51.8292 41.0067 51.6843 40.8869C51.5344 40.7622 51.3895 40.6325 51.2495 40.4978C51.2196 40.4679 51.1908 40.4379 51.1621 40.408C51.1334 40.3781 51.1046 40.3481 51.0747 40.3182C51.0715 40.315 51.0683 40.3114 51.065 40.3075C51.0578 40.2993 51.0499 40.2901 51.0397 40.2833C50.8498 40.0738 50.6799 39.8493 50.52 39.6148C50.5226 39.6109 50.5252 39.6074 50.5277 39.604Z",
    fill: "url(#paint32_radial_578_447519)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1338 38.5516C52.1338 38.5516 51.5042 38.9457 51.0695 39.6142C51.0695 39.6093 51.3793 38.9208 52.1338 38.5516Z",
    fill: "url(#paint33_radial_578_447519)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1934 39.6102C53.1934 39.6102 52.8186 40.2687 52.184 40.6629L52.134 41.1418L52.0991 40.6529C52.0991 40.6529 51.6244 40.4533 51.0697 39.6102C51.0697 39.6102 51.7693 40.5481 52.144 40.598C52.144 40.603 52.5788 40.4334 53.1934 39.6102Z",
    fill: "url(#paint34_radial_578_447519)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1289 40.6678C52.1289 40.6678 51.4693 40.2937 51.0746 39.6601L50.5949 39.6102L51.0846 39.5753C51.0846 39.5753 51.2845 39.1014 52.1289 38.5476C52.1289 38.5476 51.1895 39.246 51.1395 39.6202C51.1345 39.6202 51.3044 40.0542 52.1289 40.6678Z",
    fill: "url(#paint35_radial_578_447519)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1535 38.5476C52.1535 38.5476 52.8131 38.9218 53.2078 39.5553L53.6875 39.6052L53.1978 39.6401C53.1978 39.6401 52.9979 40.1141 52.1535 40.6678C52.1535 40.6678 53.0929 39.9694 53.1429 39.5952C53.1478 39.5952 52.978 39.1612 52.1535 38.5476Z",
    fill: "url(#paint36_radial_578_447519)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0697 39.6044C51.0697 39.6044 51.4445 38.9459 52.0791 38.5518L52.129 38.0729L52.164 38.5618C52.164 38.5618 52.6387 38.7613 53.1934 39.6044C53.1934 39.6044 52.4938 38.6665 52.1191 38.6167C52.1191 38.6117 51.6843 38.7813 51.0697 39.6044Z",
    fill: "url(#paint37_radial_578_447519)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7023 41.5C44.6813 41.5312 44.6814 41.572 44.7024 41.6032C44.9017 41.8992 45.1248 42.1829 45.3658 42.4487C45.3792 42.4621 45.3926 42.4822 45.4127 42.4956C45.4865 42.5759 45.567 42.6563 45.6475 42.7366C45.8354 42.924 46.0232 43.0981 46.2312 43.2588C46.4101 43.4065 46.5946 43.5429 46.79 43.6731C46.8213 43.694 46.862 43.694 46.8929 43.6726C47.2173 43.4477 47.7095 43.0279 48.1239 42.6082C48.4838 42.2435 48.8515 41.7578 48.9697 41.5982C48.9934 41.5662 48.9937 41.5231 48.9708 41.4905C48.8974 41.3859 48.7345 41.156 48.6331 41.0294C48.4452 40.7951 48.244 40.5675 48.036 40.3533C47.9219 40.2395 47.8079 40.1324 47.6871 40.0252C47.4346 39.8048 47.1702 39.6021 46.8939 39.4116C46.8624 39.3899 46.8209 39.3897 46.7892 39.411C46.5864 39.5476 46.3897 39.6904 46.2044 39.8445C46.0098 40.0052 45.8287 40.1725 45.6542 40.3466C45.2937 40.7128 44.9763 41.0914 44.7023 41.5Z",
    fill: "#EAF7FA"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7023 41.5C44.6813 41.5312 44.6814 41.572 44.7024 41.6032C44.9017 41.8992 45.1248 42.1829 45.3658 42.4487C45.3792 42.4621 45.3926 42.4822 45.4127 42.4956C45.4865 42.5759 45.567 42.6563 45.6475 42.7366C45.8354 42.924 46.0232 43.0981 46.2312 43.2588C46.4101 43.4065 46.5946 43.5429 46.79 43.6731C46.8213 43.694 46.862 43.694 46.8929 43.6726C47.2173 43.4477 47.7095 43.0279 48.1239 42.6082C48.4838 42.2435 48.8515 41.7578 48.9697 41.5982C48.9934 41.5662 48.9937 41.5231 48.9708 41.4905C48.8974 41.3859 48.7345 41.156 48.6331 41.0294C48.4452 40.7951 48.244 40.5675 48.036 40.3533C47.9219 40.2395 47.8079 40.1324 47.6871 40.0252C47.4346 39.8048 47.1702 39.6021 46.8939 39.4116C46.8624 39.3899 46.8209 39.3897 46.7892 39.411C46.5864 39.5476 46.3897 39.6904 46.2044 39.8445C46.0098 40.0052 45.8287 40.1725 45.6542 40.3466C45.2937 40.7128 44.9763 41.0914 44.7023 41.5Z",
    fill: "#00386A"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2241 41.5492C45.379 41.7837 45.5539 42.0082 45.7438 42.2177C45.7538 42.2277 45.7638 42.2426 45.7788 42.2526C45.8337 42.3125 45.8937 42.3724 45.9536 42.4322C46.0936 42.5719 46.2335 42.7016 46.3884 42.8213C46.5333 42.9411 46.6832 43.0508 46.8431 43.1556C47.0829 42.9959 47.3078 42.8213 47.5226 42.6318C47.8674 42.3225 48.1722 41.9733 48.432 41.5841C48.442 41.5692 48.452 41.5592 48.457 41.5442C48.3671 41.4145 48.2771 41.2848 48.1772 41.1601C48.0373 40.9855 47.8874 40.8159 47.7325 40.6562C47.6476 40.5714 47.5626 40.4916 47.4727 40.4118C47.2728 40.2372 47.0629 40.0775 46.8431 39.9279C46.6782 40.0376 46.5183 40.1524 46.3684 40.2771C46.2235 40.3968 46.0886 40.5215 45.9586 40.6512C45.6788 40.9356 45.434 41.2299 45.2241 41.5492Z",
    fill: "url(#paint38_radial_578_447519)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2239 41.5495H46.8379V39.9431C46.5181 40.1526 46.2183 40.3971 45.9485 40.6665C45.6786 40.9359 45.4338 41.2302 45.2239 41.5495Z",
    fill: "url(#paint39_radial_578_447519)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8382 39.9431V41.5545H48.4521C48.2423 41.2352 47.9974 40.9359 47.7276 40.6665C47.4528 40.3971 47.158 40.1526 46.8382 39.9431Z",
    fill: "url(#paint40_radial_578_447519)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8382 41.5496V43.1609C47.4778 42.7369 48.0274 42.1881 48.4521 41.5496H46.8382Z",
    fill: "url(#paint41_radial_578_447519)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2239 41.5496C45.4338 41.8688 45.6786 42.1682 45.9485 42.4376C46.2183 42.707 46.5181 42.9514 46.8379 43.1609V41.5496H45.2239Z",
    fill: "url(#paint42_radial_578_447519)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2243 41.5493C45.4342 41.8686 45.679 42.1679 45.9489 42.4373C46.2187 42.7067 46.5185 42.9511 46.8383 43.1607C47.0781 43.001 47.1631 42.9461 47.3779 42.7566L46.3636 40.2921C46.2187 40.4118 46.0838 40.5366 45.9538 40.6663C45.679 40.9357 45.4342 41.23 45.2243 41.5493Z",
    fill: "url(#paint43_radial_578_447519)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7735 42.2574C45.8284 42.3172 45.8884 42.3771 45.9484 42.437C46.2182 42.7064 46.518 42.9508 46.8378 43.1603C47.0776 43.0007 47.3025 42.8261 47.5173 42.6365C47.8621 42.3272 48.1669 41.978 48.4268 41.5889C47.7522 41.7884 46.7628 42.0628 45.7735 42.2574Z",
    fill: "url(#paint44_radial_578_447519)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7436 42.2178C45.7536 42.2278 45.7636 42.2428 45.7786 42.2527C45.8336 42.3126 45.8935 42.3725 45.9535 42.4323C46.0934 42.572 46.2333 42.7017 46.3882 42.8215C46.7679 42.148 47.1877 41.3398 47.2227 41.0255C47.2177 41.0305 46.3782 41.7239 45.7436 42.2178Z",
    fill: "url(#paint45_radial_578_447519)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8377 41.5494L48.1719 41.1653C48.032 40.9907 47.8821 40.8211 47.7272 40.6614C47.6422 40.5766 47.5573 40.4968 47.4673 40.417L46.8377 41.5494Z",
    fill: "url(#paint46_radial_578_447519)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M46.838 42.6124C47.2578 42.333 47.6225 41.9738 47.9023 41.5498C47.6225 41.1307 47.2628 40.7666 46.838 40.4872C46.4183 40.7666 46.0535 41.1257 45.7737 41.5498C46.0535 41.9738 46.4133 42.333 46.838 42.6124Z",
    fill: "url(#paint47_radial_578_447519)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1723 41.2399C48.0324 41.0653 47.8825 40.8957 47.7276 40.736C47.6427 40.6512 47.5577 40.5714 47.4678 40.4916C47.2679 40.317 47.058 40.1573 46.8382 40.0077C46.6733 40.1174 46.5134 40.2322 46.3635 40.3569C46.2186 40.4766 46.0837 40.6013 45.9538 40.731C45.6939 40.9905 45.4591 41.2748 45.2542 41.5791C45.2442 41.5642 45.2392 41.5542 45.2292 41.5392C45.4391 41.2199 45.6839 40.9206 45.9538 40.6512C46.0837 40.5215 46.2236 40.3968 46.3635 40.2771C46.5134 40.1524 46.6733 40.0326 46.8382 39.9279C47.058 40.0725 47.2679 40.2372 47.4678 40.4118C47.5577 40.4916 47.6427 40.5714 47.7276 40.6562C47.8875 40.8159 48.0374 40.9805 48.1723 41.1601C48.2723 41.2848 48.3622 41.4145 48.4521 41.5442C48.4422 41.5592 48.4372 41.5692 48.4272 41.5841C48.3422 41.4694 48.2573 41.3546 48.1723 41.2399Z",
    fill: "url(#paint48_radial_578_447519)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7438 42.1431C45.7538 42.1531 45.7638 42.168 45.7788 42.178C45.8337 42.2379 45.8937 42.2977 45.9536 42.3576C46.0936 42.4973 46.2335 42.627 46.3884 42.7467C46.5333 42.8665 46.6832 42.9762 46.8431 43.081C47.0829 42.9213 47.3078 42.7467 47.5226 42.5572C47.8674 42.2479 48.1722 41.8986 48.432 41.5095C48.442 41.5245 48.452 41.5345 48.457 41.5494C48.447 41.5644 48.437 41.5744 48.432 41.5893C48.1722 41.9735 47.8674 42.3227 47.5226 42.637C47.3128 42.8266 47.0829 43.0062 46.8431 43.1608C46.6882 43.056 46.5333 42.9463 46.3884 42.8266C46.2385 42.7018 46.0936 42.5721 45.9536 42.4374C45.8937 42.3776 45.8387 42.3177 45.7788 42.2578C45.7688 42.2479 45.7588 42.2329 45.7438 42.2229C45.5539 42.0134 45.384 41.7889 45.2241 41.5544C45.2341 41.5395 45.2441 41.5295 45.2491 41.5145C45.399 41.734 45.5639 41.9435 45.7438 42.1431Z",
    fill: "url(#paint49_radial_578_447519)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.7273 40.736C47.8822 40.8957 48.0321 41.0653 48.172 41.2399L48.4032 41.5522C48.1498 41.9242 47.8547 42.2592 47.5226 42.5571C47.3078 42.7467 47.0829 42.9213 46.8431 43.0809C46.6832 42.9762 46.5333 42.8664 46.3884 42.7467C46.2335 42.627 46.0936 42.4972 45.9536 42.3576C45.8937 42.2977 45.8337 42.2378 45.7788 42.178C45.7685 42.1711 45.7606 42.162 45.7534 42.1537C45.7501 42.1499 45.7469 42.1462 45.7438 42.143C45.5736 41.9543 45.4169 41.7566 45.2736 41.5501C45.4738 41.2567 45.7019 40.9822 45.9535 40.731C46.0834 40.6013 46.2183 40.4766 46.3632 40.3569C46.5131 40.2322 46.673 40.1174 46.8379 40.0077C47.0577 40.1573 47.2676 40.317 47.4675 40.4916C47.5574 40.5714 47.6424 40.6512 47.7273 40.736ZM45.2318 41.5436C45.2309 41.5422 45.2299 41.5407 45.2289 41.5392C45.4388 41.2199 45.6836 40.9206 45.9535 40.6512C46.0834 40.5215 46.2233 40.3968 46.3632 40.2771C46.5131 40.1524 46.673 40.0326 46.8379 39.9279C47.0577 40.0725 47.2676 40.2372 47.4675 40.4118C47.5574 40.4916 47.6424 40.5714 47.7273 40.6562C47.8872 40.8159 48.0371 40.9805 48.172 41.1601C48.2638 41.2747 48.3472 41.3935 48.4299 41.5126C48.4306 41.5116 48.4313 41.5105 48.432 41.5095C48.435 41.5139 48.438 41.518 48.4409 41.5218C48.4476 41.5308 48.4535 41.5389 48.457 41.5494C48.454 41.5538 48.4511 41.5579 48.4482 41.5617C48.4415 41.5707 48.4356 41.5788 48.432 41.5893C48.1722 41.9734 47.8674 42.3226 47.5226 42.6369C47.3128 42.8265 47.0829 43.0061 46.8431 43.1608C46.6882 43.056 46.5333 42.9462 46.3884 42.8265C46.2385 42.7018 46.0936 42.5721 45.9536 42.4374C45.9237 42.4074 45.8949 42.3775 45.8662 42.3476C45.8375 42.3176 45.8087 42.2877 45.7788 42.2578C45.7756 42.2546 45.7724 42.251 45.7691 42.2471C45.7619 42.2388 45.754 42.2297 45.7438 42.2229C45.5539 42.0133 45.384 41.7888 45.2241 41.5544C45.2267 41.5505 45.2293 41.547 45.2318 41.5436Z",
    fill: "url(#paint50_radial_578_447519)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8379 40.4912C46.8379 40.4912 46.2083 40.8853 45.7736 41.5538C45.7736 41.5488 46.0834 40.8604 46.8379 40.4912Z",
    fill: "url(#paint51_radial_578_447519)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M47.8975 41.5498C47.8975 41.5498 47.5227 42.2083 46.8881 42.6024L46.8381 43.0814L46.8032 42.5925C46.8032 42.5925 46.3285 42.3929 45.7738 41.5498C45.7738 41.5498 46.4734 42.4877 46.8481 42.5376C46.8481 42.5426 47.2829 42.373 47.8975 41.5498Z",
    fill: "url(#paint52_radial_578_447519)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M46.833 42.6074C46.833 42.6074 46.1734 42.2333 45.7787 41.5997L45.299 41.5498L45.7887 41.5149C45.7887 41.5149 45.9886 41.0409 46.833 40.4872C46.833 40.4872 45.8936 41.1856 45.8436 41.5598C45.8387 41.5598 46.0085 41.9938 46.833 42.6074Z",
    fill: "url(#paint53_radial_578_447519)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8576 40.4872C46.8576 40.4872 47.5172 40.8613 47.9119 41.4949L48.3916 41.5448L47.9019 41.5797C47.9019 41.5797 47.702 42.0537 46.8576 42.6074C46.8576 42.6074 47.797 41.909 47.847 41.5348C47.852 41.5348 47.6821 41.1008 46.8576 40.4872Z",
    fill: "url(#paint54_radial_578_447519)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7738 41.544C45.7738 41.544 46.1486 40.8855 46.7832 40.4914L46.8331 40.0125L46.8681 40.5014C46.8681 40.5014 47.3428 40.7009 47.8975 41.544C47.8975 41.544 47.1979 40.6061 46.8232 40.5562C46.8232 40.5512 46.3884 40.7209 45.7738 41.544Z",
    fill: "url(#paint55_radial_578_447519)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4054 39.5605C39.3845 39.5917 39.3845 39.6324 39.4055 39.6636C39.6049 39.9596 39.8279 40.2434 40.0689 40.5091C40.0823 40.5225 40.0957 40.5426 40.1158 40.556C40.1896 40.6363 40.2701 40.7167 40.3507 40.797C40.5385 40.9845 40.7264 41.1585 40.9343 41.3192C41.1132 41.4669 41.2977 41.6033 41.4931 41.7336C41.5244 41.7544 41.5651 41.7544 41.596 41.733C41.9204 41.5081 42.4126 41.0883 42.827 40.6686C43.1869 40.3039 43.5546 39.8182 43.6728 39.6586C43.6965 39.6266 43.6968 39.5836 43.6739 39.551C43.6005 39.4464 43.4377 39.2164 43.3362 39.0899C43.1483 38.8556 42.9471 38.6279 42.7391 38.4137C42.625 38.2999 42.511 38.1928 42.3902 38.0857C42.1377 37.8652 41.8733 37.6625 41.597 37.472C41.5656 37.4503 41.524 37.4501 41.4924 37.4714C41.2895 37.6081 41.0928 37.7508 40.9075 37.9049C40.7129 38.0656 40.5318 38.2329 40.3574 38.407C39.9968 38.7732 39.6795 39.1518 39.4054 39.5605Z",
    fill: "#EAF7FA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4054 39.5605C39.3845 39.5917 39.3845 39.6324 39.4055 39.6636C39.6049 39.9596 39.8279 40.2434 40.0689 40.5091C40.0823 40.5225 40.0957 40.5426 40.1158 40.556C40.1896 40.6363 40.2701 40.7167 40.3507 40.797C40.5385 40.9845 40.7264 41.1585 40.9343 41.3192C41.1132 41.4669 41.2977 41.6033 41.4931 41.7336C41.5244 41.7544 41.5651 41.7544 41.596 41.733C41.9204 41.5081 42.4126 41.0883 42.827 40.6686C43.1869 40.3039 43.5546 39.8182 43.6728 39.6586C43.6965 39.6266 43.6968 39.5836 43.6739 39.551C43.6005 39.4464 43.4377 39.2164 43.3362 39.0899C43.1483 38.8556 42.9471 38.6279 42.7391 38.4137C42.625 38.2999 42.511 38.1928 42.3902 38.0857C42.1377 37.8652 41.8733 37.6625 41.597 37.472C41.5656 37.4503 41.524 37.4501 41.4924 37.4714C41.2895 37.6081 41.0928 37.7508 40.9075 37.9049C40.7129 38.0656 40.5318 38.2329 40.3574 38.407C39.9968 38.7732 39.6795 39.1518 39.4054 39.5605Z",
    fill: "#00386A"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9272 39.6096C40.0821 39.8441 40.257 40.0686 40.4469 40.2781C40.4569 40.2881 40.4669 40.3031 40.4819 40.313C40.5368 40.3729 40.5968 40.4328 40.6568 40.4926C40.7967 40.6323 40.9366 40.762 41.0915 40.8818C41.2364 41.0015 41.3863 41.1113 41.5462 41.216C41.786 41.0564 42.0109 40.8818 42.2258 40.6922C42.5705 40.3829 42.8753 40.0337 43.1352 39.6446C43.1452 39.6296 43.1552 39.6196 43.1602 39.6046C43.0702 39.4749 42.9803 39.3452 42.8803 39.2205C42.7404 39.0459 42.5905 38.8763 42.4356 38.7166C42.3507 38.6318 42.2657 38.552 42.1758 38.4722C41.9759 38.2976 41.7661 38.1379 41.5462 37.9883C41.3813 38.098 41.2214 38.2128 41.0715 38.3375C40.9266 38.4572 40.7917 38.5819 40.6618 38.7117C40.382 38.996 40.1371 39.2904 39.9272 39.6096Z",
    fill: "url(#paint56_radial_578_447519)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9271 39.6099H41.541V38.0035C41.2212 38.2131 40.9214 38.4575 40.6516 38.7269C40.3818 38.9963 40.1369 39.2906 39.9271 39.6099Z",
    fill: "url(#paint57_radial_578_447519)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5413 38.0035V39.6149H43.1553C42.9454 39.2956 42.7006 38.9963 42.4307 38.7269C42.1559 38.4575 41.8611 38.2131 41.5413 38.0035Z",
    fill: "url(#paint58_radial_578_447519)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5413 39.61V41.2214C42.1809 40.7973 42.7305 40.2485 43.1553 39.61H41.5413Z",
    fill: "url(#paint59_radial_578_447519)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9271 39.61C40.1369 39.9293 40.3818 40.2286 40.6516 40.498C40.9214 40.7674 41.2212 41.0118 41.541 41.2214V39.61H39.9271Z",
    fill: "url(#paint60_radial_578_447519)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9274 39.6097C40.1373 39.929 40.3822 40.2283 40.652 40.4977C40.9218 40.7671 41.2216 41.0116 41.5414 41.2211C41.7812 41.0614 41.8662 41.0066 42.0811 40.817L41.0667 38.3525C40.9218 38.4723 40.7869 38.597 40.657 38.7267C40.3822 38.9961 40.1373 39.2904 39.9274 39.6097Z",
    fill: "url(#paint61_radial_578_447519)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4766 40.3178C40.5316 40.3777 40.5915 40.4375 40.6515 40.4974C40.9213 40.7668 41.2211 41.0112 41.5409 41.2208C41.7808 41.0611 42.0056 40.8865 42.2205 40.6969C42.5652 40.3876 42.8701 40.0384 43.1299 39.6493C42.4553 39.8488 41.466 40.1232 40.4766 40.3178Z",
    fill: "url(#paint62_radial_578_447519)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4467 40.2783C40.4567 40.2882 40.4667 40.3032 40.4817 40.3132C40.5367 40.373 40.5966 40.4329 40.6566 40.4928C40.7965 40.6325 40.9364 40.7622 41.0913 40.8819C41.4711 40.2084 41.8908 39.4002 41.9258 39.0859C41.9208 39.0909 41.0813 39.7844 40.4467 40.2783Z",
    fill: "url(#paint63_radial_578_447519)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5409 39.6099L42.875 39.2257C42.7351 39.0511 42.5852 38.8815 42.4303 38.7219C42.3453 38.6371 42.2604 38.5572 42.1705 38.4774L41.5409 39.6099Z",
    fill: "url(#paint64_radial_578_447519)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5412 40.6728C41.9609 40.3935 42.3256 40.0343 42.6055 39.6102C42.3256 39.1912 41.9659 38.827 41.5412 38.5476C41.1214 38.827 40.7567 39.1862 40.4768 39.6102C40.7567 40.0343 41.1164 40.3935 41.5412 40.6728Z",
    fill: "url(#paint65_radial_578_447519)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8755 39.3003C42.7355 39.1257 42.5856 38.9561 42.4307 38.7965C42.3458 38.7117 42.2609 38.6318 42.1709 38.552C41.971 38.3774 41.7612 38.2178 41.5413 38.0681C41.3764 38.1779 41.2165 38.2926 41.0666 38.4173C40.9217 38.537 40.7868 38.6618 40.6569 38.7915C40.3971 39.0509 40.1622 39.3352 39.9573 39.6396C39.9473 39.6246 39.9423 39.6146 39.9324 39.5997C40.1422 39.2804 40.3871 38.981 40.6569 38.7117C40.7868 38.5819 40.9267 38.4572 41.0666 38.3375C41.2165 38.2128 41.3764 38.093 41.5413 37.9883C41.7612 38.133 41.971 38.2976 42.1709 38.4722C42.2609 38.552 42.3458 38.6318 42.4307 38.7166C42.5906 38.8763 42.7405 39.0409 42.8755 39.2205C42.9754 39.3452 43.0653 39.4749 43.1553 39.6046C43.1453 39.6196 43.1403 39.6296 43.1303 39.6446C43.0453 39.5298 42.9604 39.4151 42.8755 39.3003Z",
    fill: "url(#paint66_radial_578_447519)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4469 40.2035C40.4569 40.2135 40.4669 40.2285 40.4819 40.2384C40.5368 40.2983 40.5968 40.3582 40.6568 40.418C40.7967 40.5577 40.9366 40.6874 41.0915 40.8072C41.2364 40.9269 41.3863 41.0366 41.5462 41.1414C41.786 40.9818 42.0109 40.8072 42.2258 40.6176C42.5705 40.3083 42.8753 39.9591 43.1352 39.5699C43.1452 39.5849 43.1552 39.5949 43.1602 39.6099C43.1502 39.6248 43.1402 39.6348 43.1352 39.6498C42.8753 40.0339 42.5705 40.3831 42.2258 40.6974C42.0159 40.887 41.786 41.0666 41.5462 41.2212C41.3913 41.1165 41.2364 41.0067 41.0915 40.887C40.9416 40.7623 40.7967 40.6326 40.6568 40.4979C40.5968 40.438 40.5418 40.3781 40.4819 40.3183C40.4719 40.3083 40.4619 40.2933 40.4469 40.2833C40.257 40.0738 40.0871 39.8493 39.9272 39.6148C39.9372 39.5999 39.9472 39.5899 39.9522 39.5749C40.1021 39.7944 40.267 40.004 40.4469 40.2035Z",
    fill: "url(#paint67_radial_578_447519)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.4304 38.7965C42.5853 38.9561 42.7352 39.1257 42.8751 39.3003L43.1063 39.6126C42.8529 39.9846 42.5579 40.3196 42.2258 40.6175C42.0109 40.8071 41.786 40.9817 41.5462 41.1414C41.3863 41.0366 41.2364 40.9268 41.0915 40.8071C40.9366 40.6874 40.7967 40.5577 40.6568 40.418C40.5968 40.3581 40.5368 40.2983 40.4819 40.2384C40.4716 40.2316 40.4637 40.2224 40.4566 40.2141C40.4532 40.2103 40.4501 40.2066 40.4469 40.2035C40.2768 40.0147 40.1201 39.8171 39.9767 39.6105C40.1769 39.3171 40.405 39.0426 40.6566 38.7915C40.7865 38.6618 40.9214 38.537 41.0663 38.4173C41.2162 38.2926 41.3761 38.1779 41.541 38.0681C41.7609 38.2178 41.9707 38.3774 42.1706 38.552C42.2605 38.6318 42.3455 38.7117 42.4304 38.7965ZM39.9349 39.604C39.934 39.6026 39.933 39.6012 39.932 39.5997C40.1419 39.2804 40.3867 38.981 40.6566 38.7117C40.7865 38.5819 40.9264 38.4572 41.0663 38.3375C41.2162 38.2128 41.3761 38.093 41.541 37.9883C41.7609 38.133 41.9707 38.2976 42.1706 38.4722C42.2605 38.552 42.3455 38.6318 42.4304 38.7166C42.5903 38.8763 42.7402 39.0409 42.8751 39.2205C42.967 39.3351 43.0504 39.4539 43.1331 39.5731C43.1338 39.572 43.1345 39.5709 43.1352 39.5699C43.1382 39.5744 43.1411 39.5784 43.144 39.5822C43.1507 39.5913 43.1567 39.5993 43.1602 39.6098C43.1572 39.6143 43.1542 39.6183 43.1513 39.6221C43.1446 39.6312 43.1387 39.6392 43.1352 39.6497C42.8753 40.0338 42.5705 40.3831 42.2258 40.6974C42.0159 40.8869 41.786 41.0665 41.5462 41.2212C41.3913 41.1164 41.2364 41.0067 41.0915 40.8869C40.9416 40.7622 40.7967 40.6325 40.6568 40.4978C40.6268 40.4679 40.5981 40.4379 40.5693 40.408C40.5406 40.3781 40.5119 40.3481 40.4819 40.3182C40.4787 40.315 40.4756 40.3114 40.4722 40.3075C40.4651 40.2993 40.4572 40.2901 40.4469 40.2833C40.257 40.0738 40.0871 39.8493 39.9272 39.6148C39.9298 39.6109 39.9324 39.6074 39.9349 39.604Z",
    fill: "url(#paint68_radial_578_447519)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M41.541 38.5516C41.541 38.5516 40.9114 38.9457 40.4767 39.6142C40.4767 39.6093 40.7865 38.9208 41.541 38.5516Z",
    fill: "url(#paint69_radial_578_447519)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6006 39.6102C42.6006 39.6102 42.2258 40.2687 41.5912 40.6629L41.5413 41.1418L41.5063 40.6529C41.5063 40.6529 41.0316 40.4533 40.477 39.6102C40.477 39.6102 41.1765 40.5481 41.5513 40.598C41.5513 40.603 41.986 40.4334 42.6006 39.6102Z",
    fill: "url(#paint70_radial_578_447519)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5361 40.6678C41.5361 40.6678 40.8766 40.2937 40.4818 39.6601L40.0021 39.6102L40.4918 39.5753C40.4918 39.5753 40.6917 39.1014 41.5361 38.5476C41.5361 38.5476 40.5967 39.246 40.5468 39.6202C40.5418 39.6202 40.7117 40.0542 41.5361 40.6678Z",
    fill: "url(#paint71_radial_578_447519)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5607 38.5476C41.5607 38.5476 42.2203 38.9218 42.615 39.5553L43.0947 39.6052L42.605 39.6401C42.605 39.6401 42.4052 40.1141 41.5607 40.6678C41.5607 40.6678 42.5001 39.9694 42.5501 39.5952C42.5551 39.5952 42.3852 39.1612 41.5607 38.5476Z",
    fill: "url(#paint72_radial_578_447519)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M40.477 39.6044C40.477 39.6044 40.8517 38.9459 41.4863 38.5518L41.5363 38.0729L41.5713 38.5618C41.5713 38.5618 42.0459 38.7613 42.6006 39.6044C42.6006 39.6044 41.901 38.6665 41.5263 38.6167C41.5263 38.6117 41.0916 38.7813 40.477 39.6044Z",
    fill: "url(#paint73_radial_578_447519)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1486 37.0489C34.1276 37.0801 34.1277 37.1208 34.1487 37.152C34.348 37.448 34.571 37.7318 34.812 37.9975C34.8255 38.0109 34.8389 38.031 34.859 38.0444C34.9328 38.1247 35.0133 38.2051 35.0938 38.2854C35.2817 38.4729 35.4695 38.6469 35.6775 38.8076C35.8564 38.9553 36.0409 39.0917 36.2363 39.222C36.2676 39.2428 36.3083 39.2428 36.3392 39.2214C36.6636 38.9965 37.1558 38.5767 37.5702 38.157C37.9301 37.7924 38.2978 37.3066 38.416 37.147C38.4397 37.115 38.44 37.072 38.4171 37.0394C38.3437 36.9348 38.1808 36.7048 38.0794 36.5783C37.8915 36.344 37.6902 36.1163 37.4823 35.9021C37.3682 35.7883 37.2542 35.6812 37.1334 35.5741C36.8809 35.3536 36.6165 35.1509 36.3402 34.9604C36.3087 34.9387 36.2672 34.9385 36.2355 34.9598C36.0327 35.0965 35.836 35.2392 35.6507 35.3933C35.4561 35.554 35.275 35.7214 35.1005 35.8954C34.74 36.2616 34.4226 36.6402 34.1486 37.0489Z",
    fill: "#EAF7FA"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1486 37.0489C34.1276 37.0801 34.1277 37.1208 34.1487 37.152C34.348 37.448 34.571 37.7318 34.812 37.9975C34.8255 38.0109 34.8389 38.031 34.859 38.0444C34.9328 38.1247 35.0133 38.2051 35.0938 38.2854C35.2817 38.4729 35.4695 38.6469 35.6775 38.8076C35.8564 38.9553 36.0409 39.0917 36.2363 39.222C36.2676 39.2428 36.3083 39.2428 36.3392 39.2214C36.6636 38.9965 37.1558 38.5767 37.5702 38.157C37.9301 37.7924 38.2978 37.3066 38.416 37.147C38.4397 37.115 38.44 37.072 38.4171 37.0394C38.3437 36.9348 38.1808 36.7048 38.0794 36.5783C37.8915 36.344 37.6902 36.1163 37.4823 35.9021C37.3682 35.7883 37.2542 35.6812 37.1334 35.5741C36.8809 35.3536 36.6165 35.1509 36.3402 34.9604C36.3087 34.9387 36.2672 34.9385 36.2355 34.9598C36.0327 35.0965 35.836 35.2392 35.6507 35.3933C35.4561 35.554 35.275 35.7214 35.1005 35.8954C34.74 36.2616 34.4226 36.6402 34.1486 37.0489Z",
    fill: "#00386A"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6704 37.098C34.8253 37.3325 35.0002 37.557 35.1901 37.7665C35.2001 37.7765 35.2101 37.7915 35.225 37.8015C35.28 37.8613 35.34 37.9212 35.3999 37.981C35.5398 38.1207 35.6798 38.2504 35.8347 38.3702C35.9796 38.4899 36.1295 38.5997 36.2894 38.7044C36.5292 38.5448 36.7541 38.3702 36.9689 38.1806C37.3137 37.8713 37.6185 37.5221 37.8783 37.133C37.8883 37.118 37.8983 37.108 37.9033 37.093C37.8134 36.9633 37.7234 36.8336 37.6235 36.7089C37.4836 36.5343 37.3337 36.3647 37.1788 36.205C37.0938 36.1202 37.0089 36.0404 36.919 35.9606C36.7191 35.786 36.5092 35.6263 36.2894 35.4767C36.1245 35.5864 35.9646 35.7012 35.8147 35.8259C35.6698 35.9456 35.5348 36.0703 35.4049 36.2001C35.1251 36.4844 34.8803 36.7788 34.6704 37.098Z",
    fill: "url(#paint74_radial_578_447519)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6702 37.0983H36.2842V35.4919C35.9644 35.7015 35.6646 35.9459 35.3948 36.2153C35.1249 36.4847 34.8801 36.779 34.6702 37.0983Z",
    fill: "url(#paint75_radial_578_447519)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2845 35.4919V37.1033H37.8984C37.6886 36.784 37.4437 36.4847 37.1739 36.2153C36.8991 35.9459 36.6043 35.7015 36.2845 35.4919Z",
    fill: "url(#paint76_radial_578_447519)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2845 37.0984V38.7098C36.9241 38.2857 37.4737 37.737 37.8984 37.0984H36.2845Z",
    fill: "url(#paint77_radial_578_447519)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6702 37.0984C34.8801 37.4177 35.1249 37.717 35.3948 37.9864C35.6646 38.2558 35.9644 38.5002 36.2842 38.7098V37.0984H34.6702Z",
    fill: "url(#paint78_radial_578_447519)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6706 37.0981C34.8805 37.4174 35.1253 37.7167 35.3951 37.9861C35.665 38.2555 35.9648 38.5 36.2846 38.7095C36.5244 38.5498 36.6094 38.495 36.8242 38.3054L35.8099 35.8409C35.665 35.9607 35.5301 36.0854 35.4001 36.2151C35.1253 36.4845 34.8805 36.7788 34.6706 37.0981Z",
    fill: "url(#paint79_radial_578_447519)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2198 37.8062C35.2747 37.8661 35.3347 37.9259 35.3946 37.9858C35.6645 38.2552 35.9643 38.4996 36.2841 38.7092C36.5239 38.5495 36.7488 38.3749 36.9636 38.1853C37.3084 37.876 37.6132 37.5268 37.873 37.1377C37.1985 37.3372 36.2091 37.6116 35.2198 37.8062Z",
    fill: "url(#paint80_radial_578_447519)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1899 37.7667C35.1999 37.7766 35.2099 37.7916 35.2249 37.8016C35.2798 37.8614 35.3398 37.9213 35.3998 37.9812C35.5397 38.1209 35.6796 38.2506 35.8345 38.3703C36.2142 37.6968 36.634 36.8886 36.6689 36.5743C36.6639 36.5793 35.8245 37.2728 35.1899 37.7667Z",
    fill: "url(#paint81_radial_578_447519)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M36.284 37.0983L37.6182 36.7141C37.4783 36.5395 37.3283 36.3699 37.1735 36.2103C37.0885 36.1255 37.0036 36.0456 36.9136 35.9658L36.284 37.0983Z",
    fill: "url(#paint82_radial_578_447519)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2843 38.1612C36.704 37.8819 37.0688 37.5227 37.3486 37.0986C37.0688 36.6796 36.709 36.3154 36.2843 36.036C35.8646 36.3154 35.4998 36.6746 35.22 37.0986C35.4998 37.5227 35.8596 37.8819 36.2843 38.1612Z",
    fill: "url(#paint83_radial_578_447519)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6186 36.7887C37.4787 36.6141 37.3288 36.4445 37.1739 36.2849C37.089 36.2001 37.004 36.1202 36.9141 36.0404C36.7142 35.8658 36.5043 35.7062 36.2845 35.5565C36.1196 35.6663 35.9597 35.781 35.8098 35.9057C35.6649 36.0254 35.53 36.1502 35.4001 36.2799C35.1402 36.5393 34.9054 36.8237 34.7005 37.128C34.6905 37.113 34.6855 37.103 34.6755 37.0881C34.8854 36.7688 35.1302 36.4694 35.4001 36.2001C35.53 36.0703 35.6699 35.9456 35.8098 35.8259C35.9597 35.7012 36.1196 35.5814 36.2845 35.4767C36.5043 35.6214 36.7142 35.786 36.9141 35.9606C37.004 36.0404 37.089 36.1202 37.1739 36.205C37.3338 36.3647 37.4837 36.5293 37.6186 36.7089C37.7186 36.8336 37.8085 36.9633 37.8984 37.093C37.8884 37.108 37.8834 37.118 37.8735 37.133C37.7885 37.0182 37.7036 36.9035 37.6186 36.7887Z",
    fill: "url(#paint84_radial_578_447519)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1901 37.6919C35.2001 37.7019 35.2101 37.7169 35.225 37.7268C35.28 37.7867 35.34 37.8466 35.3999 37.9064C35.5398 38.0461 35.6798 38.1758 35.8347 38.2956C35.9796 38.4153 36.1295 38.525 36.2894 38.6298C36.5292 38.4702 36.7541 38.2956 36.9689 38.106C37.3137 37.7967 37.6185 37.4475 37.8783 37.0583C37.8883 37.0733 37.8983 37.0833 37.9033 37.0983C37.8933 37.1132 37.8833 37.1232 37.8783 37.1382C37.6185 37.5223 37.3137 37.8715 36.9689 38.1858C36.7591 38.3754 36.5292 38.555 36.2894 38.7096C36.1345 38.6049 35.9796 38.4951 35.8347 38.3754C35.6848 38.2507 35.5398 38.121 35.3999 37.9863C35.34 37.9264 35.285 37.8665 35.225 37.8067C35.2151 37.7967 35.2051 37.7817 35.1901 37.7717C35.0002 37.5622 34.8303 37.3377 34.6704 37.1032C34.6804 37.0883 34.6904 37.0783 34.6954 37.0633C34.8453 37.2828 35.0102 37.4924 35.1901 37.6919Z",
    fill: "url(#paint85_radial_578_447519)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.1736 36.2849C37.3285 36.4445 37.4784 36.6141 37.6183 36.7887L37.8495 37.101C37.596 37.473 37.301 37.808 36.9689 38.1059C36.7541 38.2955 36.5292 38.4701 36.2894 38.6298C36.1295 38.525 35.9796 38.4152 35.8347 38.2955C35.6798 38.1758 35.5398 38.0461 35.3999 37.9064C35.34 37.8465 35.28 37.7867 35.225 37.7268C35.2148 37.72 35.2069 37.7108 35.1997 37.7025C35.1964 37.6987 35.1932 37.695 35.1901 37.6919C35.0199 37.5031 34.8632 37.3055 34.7199 37.0989C34.9201 36.8055 35.1482 36.531 35.3997 36.2799C35.5297 36.1502 35.6646 36.0254 35.8095 35.9057C35.9594 35.781 36.1193 35.6663 36.2842 35.5565C36.504 35.7062 36.7139 35.8658 36.9138 36.0404C37.0037 36.1202 37.0886 36.2001 37.1736 36.2849ZM34.6781 37.0924C34.6772 37.091 34.6762 37.0896 34.6752 37.0881C34.8851 36.7688 35.1299 36.4694 35.3997 36.2001C35.5297 36.0703 35.6696 35.9456 35.8095 35.8259C35.9594 35.7012 36.1193 35.5814 36.2842 35.4767C36.504 35.6214 36.7139 35.786 36.9138 35.9606C37.0037 36.0404 37.0886 36.1202 37.1736 36.205C37.3335 36.3647 37.4834 36.5293 37.6183 36.7089C37.7101 36.8235 37.7935 36.9423 37.8762 37.0615C37.8769 37.0604 37.8776 37.0594 37.8783 37.0583C37.8813 37.0628 37.8843 37.0668 37.8872 37.0706C37.8938 37.0797 37.8998 37.0877 37.9033 37.0982C37.9003 37.1027 37.8974 37.1067 37.8945 37.1105C37.8878 37.1196 37.8818 37.1276 37.8783 37.1381C37.6185 37.5223 37.3137 37.8715 36.9689 38.1858C36.7591 38.3753 36.5292 38.5549 36.2894 38.7096C36.1345 38.6048 35.9796 38.4951 35.8347 38.3753C35.6848 38.2506 35.5398 38.1209 35.3999 37.9862C35.37 37.9563 35.3412 37.9263 35.3125 37.8964C35.2838 37.8665 35.255 37.8365 35.225 37.8066C35.2219 37.8035 35.2187 37.7998 35.2154 37.796C35.2082 37.7877 35.2003 37.7785 35.1901 37.7717C35.0002 37.5622 34.8303 37.3377 34.6704 37.1032C34.673 37.0993 34.6756 37.0958 34.6781 37.0924Z",
    fill: "url(#paint86_radial_578_447519)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2842 36.04C36.2842 36.04 35.6546 36.4342 35.2199 37.1026C35.2199 37.0977 35.5297 36.4092 36.2842 36.04Z",
    fill: "url(#paint87_radial_578_447519)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3438 37.0986C37.3438 37.0986 36.969 37.7571 36.3344 38.1513L36.2844 38.6302L36.2495 38.1413C36.2495 38.1413 35.7748 37.9417 35.2201 37.0986C35.2201 37.0986 35.9197 38.0365 36.2944 38.0864C36.2944 38.0914 36.7291 37.9218 37.3438 37.0986Z",
    fill: "url(#paint88_radial_578_447519)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2793 38.1562C36.2793 38.1562 35.6197 37.7821 35.225 37.1485L34.7453 37.0986L35.235 37.0637C35.235 37.0637 35.4348 36.5898 36.2793 36.036C36.2793 36.036 35.3399 36.7344 35.2899 37.1086C35.2849 37.1086 35.4548 37.5426 36.2793 38.1562Z",
    fill: "url(#paint89_radial_578_447519)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3039 36.036C36.3039 36.036 36.9635 36.4102 37.3582 37.0437L37.8379 37.0936L37.3482 37.1286C37.3482 37.1286 37.1483 37.6025 36.3039 38.1562C36.3039 38.1562 37.2433 37.4578 37.2932 37.0837C37.2982 37.0837 37.1283 36.6496 36.3039 36.036Z",
    fill: "url(#paint90_radial_578_447519)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2201 37.0928C35.2201 37.0928 35.5949 36.4343 36.2295 36.0402L36.2794 35.5613L36.3144 36.0502C36.3144 36.0502 36.7891 36.2497 37.3438 37.0928C37.3438 37.0928 36.6442 36.1549 36.2694 36.1051C36.2694 36.1001 35.8347 36.2697 35.2201 37.0928Z",
    fill: "url(#paint91_radial_578_447519)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M48.126 43.9825C47.0948 44.4365 45.9218 44.4365 44.8906 43.9825L40.7754 42.4694L44.9663 44.3325C45.9974 44.7864 47.1705 44.7864 48.2017 44.3325L52.5439 42.4032L48.126 43.9825Z",
    fill: "url(#paint92_radial_578_447519)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2549 39.1211C33.2549 39.1211 36.0078 40.7288 40.7852 42.4689C40.7758 42.4689 36.6889 40.568 33.2549 39.1211Z",
    fill: "url(#paint93_radial_578_447519)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M59.9236 39.1211C59.9236 39.1211 57.0761 40.7478 53.7461 41.8448C53.7461 41.8543 56.8964 40.3127 59.9236 39.1211Z",
    fill: "url(#paint94_radial_578_447519)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7304 36.4167L45.7805 37.8732C41.9491 37.4665 37.9663 34.0524 34.9107 34.0524C33.9363 34.0524 33.1132 34.1848 32.4415 34.374L30.8428 27.7161L36.2162 30.1182L38.2501 33.8254L44.7304 36.4167Z",
    fill: "url(#paint95_radial_578_447519)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3358 27.7059L60.7843 34.1463C60.1788 34.0801 59.4693 34.0423 58.6558 34.0423C54.6257 34.0423 51.1254 37.3523 47.417 37.8441L48.4481 36.4066L54.9284 33.8153L56.9624 30.1081L62.3358 27.7059Z",
    fill: "url(#paint96_radial_578_447519)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7304 36.4167L45.7805 37.8732C41.9491 37.4665 37.9663 34.0524 34.9107 34.0524C33.9363 34.0524 33.1132 34.1848 32.4415 34.374L30.8428 27.7161L36.2162 30.1182L38.2501 33.8254L44.7304 36.4167Z",
    fill: "url(#paint97_linear_578_447519)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3358 27.7059L60.7843 34.1463C60.1788 34.0801 59.4693 34.0423 58.6558 34.0423C54.6257 34.0423 51.1254 37.3523 47.417 37.8441L48.4481 36.4066L54.9284 33.8153L56.9624 30.1081L62.3358 27.7059Z",
    fill: "url(#paint98_linear_578_447519)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6699 14.173L47.7172 15.2984C47.7172 15.2984 50.4796 16.9912 51.7662 18.8259L52.6365 18.4098C52.6365 18.4192 49.9215 15.3078 47.6699 14.173Z",
    fill: "url(#paint99_radial_578_447519)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0205 19.081L52.8341 18.7878L53.7139 19.9132L52.7395 20.0646L52.0205 19.081Z",
    fill: "url(#paint100_radial_578_447519)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M52.835 20.3107L53.7621 20.2634L54.0175 20.7268L53.0431 20.7741L52.835 20.3107Z",
    fill: "url(#paint101_radial_578_447519)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M87.1781 9.05701C87.1781 9.05701 86.7051 9.92707 85.778 11.3267C85.7213 11.4119 85.6645 11.4875 85.6077 11.5726C84.4157 13.2371 82.6656 14.4098 80.66 14.8543C73.1013 16.5282 62.714 18.8452 58.1731 19.8666C58.1636 19.1289 58.1068 18.3818 57.9649 17.6253C57.842 16.9727 57.6811 16.3201 57.4541 15.6581L87.1781 9.05701Z",
    fill: "url(#paint102_radial_578_447519)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M85.6076 11.5721C84.4156 13.2366 82.6655 14.4093 80.6599 14.8538C73.1012 16.5277 62.7139 18.8447 58.173 19.8661C58.1635 19.1284 58.1067 18.3814 57.9648 17.6248C62.7044 16.6034 78.2287 13.265 85.6076 11.5721Z",
    fill: "url(#paint103_radial_578_447519)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7777 10.9012C85.721 10.9863 85.6642 11.0619 85.6074 11.1471C84.4154 12.8115 82.6653 13.9842 80.6597 14.4287C73.101 16.1026 62.7137 18.4196 58.1728 19.441C58.1633 18.7034 58.1066 17.9563 57.9646 17.1997C57.87 16.6795 57.7471 16.1594 57.5768 15.6298L57.4443 15.6581C57.6714 16.3107 57.8417 16.9727 57.9552 17.6253C58.0876 18.3818 58.1539 19.1289 58.1633 19.8666C62.7042 18.8452 73.0916 16.5282 80.6503 14.8543C82.6464 14.4098 84.4155 13.2371 85.598 11.5726C85.6547 11.4875 85.7115 11.4119 85.7683 11.3267C86.6954 9.92707 87.1684 9.05701 87.1684 9.05701L86.8846 9.12323C86.667 9.52043 86.2886 10.1257 85.7777 10.9012Z",
    fill: "url(#paint104_radial_578_447519)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0303 17.1898C68.0303 17.1898 74.4159 15.4213 80.6597 14.4188C80.6597 14.4188 74.047 16.036 68.0303 17.1898Z",
    fill: "url(#paint105_radial_578_447519)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7712 14.1633C83.0522 15.1185 82.2197 16.1493 81.2831 17.2275C81.1223 17.4072 80.9615 17.5869 80.7912 17.7665C78.9275 19.6769 76.5246 20.982 73.8947 21.5021L57.4434 24.7365C57.6609 24.0177 57.8501 23.2517 57.9826 22.4573C58.1245 21.6251 58.1907 20.755 58.1813 19.866L83.7712 14.1633Z",
    fill: "url(#paint106_radial_578_447519)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7824 17.7573C78.9188 19.6677 76.5159 20.9728 73.8859 21.4929L57.4346 24.7273C57.6522 24.0086 57.8414 23.2425 57.9738 22.4481C62.2688 21.6915 73.3467 19.6582 80.7824 17.7573Z",
    fill: "url(#paint107_radial_578_447519)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M81.2743 16.7545C81.1135 16.9342 80.9527 17.1139 80.7824 17.2936C78.9188 19.204 76.5159 20.5091 73.8859 21.0292L57.5765 24.2352C57.5292 24.4055 57.4819 24.5662 57.4346 24.727L73.8859 21.4926C76.5159 20.9725 78.9188 19.6674 80.7824 17.757C80.9527 17.5868 81.1135 17.4071 81.2743 17.2179C82.2109 16.1398 83.0434 15.109 83.7624 14.1538L83.3367 14.2484C82.7218 15.0522 82.0312 15.8939 81.2743 16.7545Z",
    fill: "url(#paint108_radial_578_447519)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0303 22.1834C68.0303 22.1834 75.116 21.389 77.3865 19.8191C77.3865 19.8191 73.451 21.2471 68.0303 22.1834Z",
    fill: "url(#paint109_radial_578_447519)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9548 20.6892C77.3494 21.2661 76.7344 21.8241 76.0722 22.3915C76.0344 22.4293 75.9871 22.4672 75.9398 22.505C73.1396 24.8977 69.7433 26.4865 66.1201 27.1107L55.5908 28.9454C55.9881 28.2361 56.4044 27.4039 56.7828 26.4771C57.0099 25.9285 57.2275 25.3422 57.4072 24.7275L77.9548 20.6892Z",
    fill: "url(#paint110_radial_578_447519)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M76.082 22.3916C76.0441 22.4294 75.9969 22.4673 75.9496 22.5051C73.1493 24.8978 69.7531 26.4866 66.1298 27.1107L55.6006 28.9454C55.9979 28.2362 56.4142 27.404 56.7926 26.4771C58.8738 26.2975 70.4721 24.5195 76.082 22.3916Z",
    fill: "url(#paint111_radial_578_447519)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M76.082 21.9469C76.0441 21.9847 75.9969 22.0226 75.9496 22.0604C73.1493 24.4531 69.7531 26.0419 66.1298 26.6661L55.8749 28.444C55.7803 28.6142 55.6952 28.775 55.6006 28.9358L66.1298 27.1105C69.7626 26.4769 73.1493 24.8881 75.9496 22.5049C75.9874 22.4671 76.0347 22.4292 76.082 22.3914C76.7347 21.8334 77.3591 21.2565 77.9646 20.6891L77.3591 20.812C76.9429 21.1903 76.5172 21.5686 76.082 21.9469Z",
    fill: "url(#paint112_radial_578_447519)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M64.8621 26.9879C64.6445 27.0352 69.8098 26.638 73.1588 24.0562C73.1588 24.0656 69.8098 25.9476 64.8621 26.9879Z",
    fill: "url(#paint113_radial_578_447519)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7737 26.3068C66.0909 29.2196 60.4526 31.357 53.9629 31.4421C53.9629 31.4421 54.3791 30.9313 54.9562 30.0329C55.1549 29.7208 55.3819 29.352 55.609 28.9453L70.7737 26.3068Z",
    fill: "url(#paint114_radial_578_447519)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7737 26.3068C66.0909 29.2196 60.4526 31.357 53.9629 31.4421C53.9629 31.4421 54.3791 30.9313 54.9562 30.0329C57.2929 29.8248 63.5461 29.0683 70.7737 26.3068Z",
    fill: "url(#paint115_radial_578_447519)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2467 31.054C54.067 31.2999 53.9629 31.4323 53.9629 31.4323C60.4621 31.3377 66.0909 29.2098 70.7737 26.297L69.9885 26.4294C65.5422 29.0585 60.2729 30.9311 54.2467 31.054Z",
    fill: "url(#paint116_radial_578_447519)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8447 30.5718C58.8447 30.5718 63.2059 30.2125 67.8319 27.6685C67.8225 27.6685 63.5086 29.5315 58.8447 30.5718Z",
    fill: "url(#paint117_radial_578_447519)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.05713C6 9.05713 6.47302 9.92719 7.40012 11.3269C7.45688 11.412 7.51365 11.4876 7.57041 11.5728C8.7624 13.2372 10.5125 14.4099 12.5181 14.8544C20.0768 16.5283 30.4642 18.8453 35.0051 19.8667C35.0145 19.1291 35.0713 18.382 35.2132 17.6254C35.3362 16.9728 35.497 16.3203 35.724 15.6583L6 9.05713Z",
    fill: "url(#paint118_radial_578_447519)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56055 11.5724C8.75254 13.2369 10.5027 14.4095 12.5083 14.854C20.067 16.528 30.4543 18.845 34.9952 19.8664C35.0047 19.1287 35.0614 18.3816 35.2033 17.625C30.4638 16.6036 14.9395 13.2652 7.56055 11.5724Z",
    fill: "url(#paint119_radial_578_447519)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40041 10.9013C7.45718 10.9864 7.51394 11.0621 7.5707 11.1472C8.76269 12.8117 10.5128 13.9843 12.5184 14.4288C20.0771 16.1027 30.4645 18.4198 35.0054 19.4411C35.0148 18.7035 35.0716 17.9564 35.2135 17.1998C35.3081 16.6797 35.4311 16.1595 35.6014 15.6299L35.7338 15.6583C35.5068 16.3108 35.3365 16.9728 35.223 17.6254C35.0905 18.382 35.0243 19.1291 35.0148 19.8667C30.4739 18.8453 20.0866 16.5283 12.5279 14.8544C10.5317 14.4099 8.76268 13.2372 7.58015 11.5728C7.52339 11.4876 7.46665 11.412 7.40988 11.3269C6.48278 9.92719 6.00977 9.05713 6.00977 9.05713L6.29357 9.12335C6.51116 9.52055 6.88956 10.1258 7.40041 10.9013Z",
    fill: "url(#paint120_radial_578_447519)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1382 17.1899C25.1382 17.1899 18.7525 15.4214 12.5088 14.4189C12.5182 14.4189 19.1309 16.0361 25.1382 17.1899Z",
    fill: "url(#paint121_radial_578_447519)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40625 14.1635C10.1252 15.1186 10.9577 16.1495 11.8943 17.2276C12.0551 17.4073 12.2159 17.587 12.3862 17.7667C14.2499 19.677 16.6528 20.9821 19.2827 21.5023L35.7341 24.7366C35.5165 24.0179 35.3273 23.2519 35.1948 22.4575C35.0529 21.6252 34.9867 20.7551 34.9962 19.8661L9.40625 14.1635Z",
    fill: "url(#paint122_radial_578_447519)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3857 17.7574C14.2494 19.6678 16.6523 20.9729 19.2823 21.4931L35.7336 24.7274C35.516 24.0087 35.3268 23.2427 35.1944 22.4482C30.8994 21.6917 19.8215 19.6583 12.3857 17.7574Z",
    fill: "url(#paint123_radial_578_447519)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8943 16.7547C12.0551 16.9344 12.2159 17.1141 12.3862 17.2937C14.2499 19.2041 16.6528 20.5092 19.2827 21.0294L35.5922 24.2353C35.6395 24.4056 35.6868 24.5664 35.7341 24.7271L19.2827 21.4928C16.6528 20.9726 14.2499 19.6675 12.3862 17.7571C12.2159 17.5869 12.0551 17.4072 11.8943 17.2181C10.9577 16.1399 10.1252 15.1091 9.40625 14.1539L9.83196 14.2485C10.4469 15.0524 11.1375 15.8941 11.8943 16.7547Z",
    fill: "url(#paint124_radial_578_447519)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1384 22.1835C25.1384 22.1835 18.0527 21.3891 15.7822 19.8192C15.7917 19.8192 19.7271 21.2473 25.1384 22.1835Z",
    fill: "url(#paint125_radial_578_447519)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2139 20.6896C15.8193 21.2665 16.4342 21.8244 17.0964 22.3919C17.1343 22.4297 17.1816 22.4676 17.2289 22.5054C20.0291 24.8981 23.4253 26.4868 27.0486 27.111L37.5778 28.9457C37.1805 28.2364 36.7643 27.4042 36.3858 26.4774C36.1588 25.9289 35.9412 25.3426 35.7615 24.7278L15.2139 20.6896Z",
    fill: "url(#paint126_radial_578_447519)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0967 22.3916C17.1345 22.4294 17.1818 22.4673 17.2291 22.5051C20.0293 24.8978 23.4256 26.4866 27.0488 27.1107L37.5781 28.9454C37.1807 28.2362 36.7645 27.404 36.3861 26.4771C34.2954 26.2975 22.6971 24.5195 17.0967 22.3916Z",
    fill: "url(#paint127_radial_578_447519)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0964 21.9471C17.1343 21.9849 17.1816 22.0227 17.2289 22.0606C20.0291 24.4533 23.4253 26.0421 27.0486 26.6663L37.3035 28.4442C37.3981 28.6144 37.4832 28.7752 37.5778 28.936L27.0486 27.1013C23.4159 26.4676 20.0291 24.8788 17.2289 22.4956C17.191 22.4578 17.1437 22.4199 17.0964 22.3821C16.4437 21.8241 15.8193 21.2472 15.2139 20.6798L15.8193 20.8028C16.2261 21.1905 16.6518 21.5688 17.0964 21.9471Z",
    fill: "url(#paint128_radial_578_447519)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3074 26.9879C28.5249 27.0352 23.3597 26.638 20.0107 24.0562C20.0107 24.0656 23.3597 25.9476 28.3074 26.9879Z",
    fill: "url(#paint129_radial_578_447519)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3945 26.3069C27.0773 29.2197 32.7156 31.3571 39.2054 31.4422C39.2054 31.4422 38.7891 30.9315 38.212 30.033C38.0134 29.7209 37.7863 29.3521 37.5593 28.9454L22.3945 26.3069Z",
    fill: "url(#paint130_radial_578_447519)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3945 26.3069C27.0773 29.2197 32.7156 31.3571 39.2054 31.4422C39.2054 31.4422 38.7891 30.9315 38.212 30.033C35.8754 29.825 29.6221 29.0684 22.3945 26.3069Z",
    fill: "url(#paint131_radial_578_447519)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9215 31.0541C39.1013 31.3 39.2054 31.4324 39.2054 31.4324C32.7062 31.3379 27.0773 29.2099 22.3945 26.2971L23.1797 26.4296C27.6355 29.0587 32.9048 30.9312 38.9215 31.0541Z",
    fill: "url(#paint132_radial_578_447519)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3339 30.572C34.3339 30.572 29.9727 30.2126 25.3467 27.6686C25.3561 27.6686 29.6605 29.5317 34.3339 30.572Z",
    fill: "url(#paint133_radial_578_447519)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8955 29.2288V15.4874L70.0263 22.3628L65.9016 24.538L62.8744 26.0701L56.8955 29.2288Z",
    fill: "url(#paint134_radial_578_447519)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8939 22.3628H68.3329L64.4069 20.2823L62.4108 19.2325L57.6712 16.7263L56.8955 15.4874L62.7419 18.58L64.7759 19.6486L69.8939 22.3628Z",
    fill: "url(#paint135_radial_578_447519)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8955 15.4874L57.6712 16.7263V27.9993L56.8955 29.2288V15.4874Z",
    fill: "url(#paint136_radial_578_447519)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3261 23.6112L56.9232 24.6894L56.9043 21.3415L59.3545 19.6676L59.3261 23.6112Z",
    fill: "url(#paint137_radial_578_447519)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M61.6449 18.7599L59.6582 17.7102L59.9799 17.0576L62.0138 18.1357L61.6449 18.7599Z",
    fill: "url(#paint138_radial_578_447519)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M57.6709 27.9996V16.7266L61.8145 18.9112L68.3326 22.3631L63.9714 24.6801L57.6709 27.9996Z",
    fill: "url(#paint139_radial_578_447519)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6396 23.2333C66.6396 23.2333 62.9691 25.0113 58.3809 27.6971C58.3809 27.6877 62.7137 25.5976 66.6396 23.2333Z",
    fill: "url(#paint140_radial_578_447519)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0716 21.143C66.0716 21.143 62.4295 18.9679 57.6426 16.6981C57.6426 16.6981 60.8401 18.4572 66.0716 21.143Z",
    fill: "url(#paint141_radial_578_447519)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M57.69 28.5292C57.69 28.5292 57.8413 23.4601 57.6049 17.0292C57.6049 17.0386 57.586 21.4268 57.69 28.5292Z",
    fill: "url(#paint142_radial_578_447519)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8654 22.3349C69.8654 22.3349 69.3262 22.2308 68.5883 22.3916C68.5788 22.3822 68.7396 22.5335 69.8654 22.3349Z",
    fill: "url(#paint143_radial_578_447519)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5786 22.382H57.7939L57.6709 27.9995L68.5786 22.382Z",
    fill: "url(#paint144_radial_578_447519)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M60.017 19.0624L57.4533 19.3461L57.3587 19.1569L57.8507 18.9773C57.8223 18.0221 57.5952 16.5279 56.583 15.3552L56.1289 14.6175L56.9141 14.0406L60.9442 11.0521L61.0104 11.3074C61.0009 11.3074 59.4684 16.0361 60.017 19.0624Z",
    fill: "url(#paint145_radial_578_447519)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M60.0167 19.0624L59.5626 18.3248C58.3422 18.2208 57.3773 15.6011 56.9043 14.0312L60.9343 11.0427L61.0006 11.2981C61.0006 11.3075 59.468 16.0361 60.0167 19.0624Z",
    fill: "url(#paint146_radial_578_447519)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4715 12.2248C59.9418 13.7095 59.1944 16.3008 59.5539 18.3341L57.3497 19.1569C57.3497 19.1569 57.501 18.0599 57.1888 16.7832C57.0185 16.0644 56.6969 15.2794 56.1104 14.6174L60.9162 11.0426C60.9351 11.0426 60.727 11.4965 60.4715 12.2248Z",
    fill: "url(#paint147_radial_578_447519)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3594 19.157L59.4785 18.391L60.0177 19.0625L59.5447 18.2681C59.5447 18.2681 59.3649 17.3602 59.4785 16.6698C59.4785 16.6698 59.3649 17.9371 59.4406 18.2302L57.3594 19.157Z",
    fill: "url(#paint148_radial_578_447519)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4785 16.5468C59.4785 16.5468 59.4974 14.4757 60.5286 12.083C60.5286 12.083 59.6772 14.6176 59.4785 16.5468Z",
    fill: "url(#paint149_radial_578_447519)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9354 11.0426C60.9354 11.0426 60.7367 11.4965 60.4718 12.2153C59.119 13.6906 57.4729 16.3387 57.1986 16.7832C57.0283 16.0644 56.7067 15.2794 56.1201 14.6174L60.9354 11.0426Z",
    fill: "url(#paint150_radial_578_447519)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7374 26.004L57.5482 25.8054L56.167 29.7396L56.2711 29.7869L59.2794 28.775L57.7374 26.004Z",
    fill: "url(#paint151_radial_578_447519)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8253 28.4629L56.167 29.7396L56.517 28.7466L57.5482 25.8054L58.1063 26.9592L58.8253 28.4629Z",
    fill: "url(#paint152_radial_578_447519)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8253 28.4629L59.2794 28.775L56.2711 29.7869L56.167 29.7396L58.8253 28.4629Z",
    fill: "url(#paint153_radial_578_447519)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2294 27.1864L58.7592 28.482L56.8955 29.3994L58.8159 28.5482L59.2795 28.7752L58.8538 28.4537L58.2294 27.1864Z",
    fill: "url(#paint154_radial_578_447519)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1056 26.9594C57.5002 27.593 56.8758 28.3212 56.5068 28.7373L57.538 25.7961L58.1056 26.9594Z",
    fill: "url(#paint155_radial_578_447519)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2727 29.2288V15.4874L23.1514 22.3628L27.2666 24.538L30.2938 26.0701L36.2727 29.2288Z",
    fill: "url(#paint156_radial_578_447519)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2734 22.363H24.8344L28.7604 20.2824L30.7565 19.2326L35.496 16.7265L36.2718 15.4875L30.4254 18.5801L28.4009 19.6487L23.2734 22.363Z",
    fill: "url(#paint157_radial_578_447519)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2728 15.4875L35.4971 16.7265V27.9994L36.2728 29.2289V15.4875Z",
    fill: "url(#paint158_radial_578_447519)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8507 23.6112L36.2535 24.6894L36.263 21.3415L33.8223 19.6676L33.8507 23.6112Z",
    fill: "url(#paint159_radial_578_447519)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5236 18.7599L33.5197 17.7102L33.1886 17.0576L31.1641 18.1357L31.5236 18.7599Z",
    fill: "url(#paint160_radial_578_447519)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4966 27.9996V16.7266L31.353 18.9112L24.835 22.3631L29.2056 24.6801L35.4966 27.9996Z",
    fill: "url(#paint161_radial_578_447519)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5283 23.2333C26.5283 23.2333 30.1989 25.0113 34.7871 27.6971C34.7871 27.6877 30.4638 25.5976 26.5283 23.2333Z",
    fill: "url(#paint162_radial_578_447519)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0957 21.143C27.0957 21.143 30.7379 18.9679 35.5248 16.6981C35.5342 16.6981 32.3272 18.4572 27.0957 21.143Z",
    fill: "url(#paint163_radial_578_447519)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4871 28.5292C35.4871 28.5292 35.3358 23.4601 35.5723 17.0292C35.5628 17.0386 35.5912 21.4268 35.4871 28.5292Z",
    fill: "url(#paint164_radial_578_447519)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3115 22.3349C23.3115 22.3349 23.8508 22.2308 24.5887 22.3916C24.5887 22.3822 24.4373 22.5335 23.3115 22.3349Z",
    fill: "url(#paint165_radial_578_447519)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5889 22.382H35.3735L35.4965 27.9995L24.5889 22.382Z",
    fill: "url(#paint166_radial_578_447519)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2727 29.2288V15.4874L23.1514 22.3628L27.2666 24.538L30.2938 26.0701L36.2727 29.2288Z",
    fill: "url(#paint167_radial_578_447519)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2734 22.363H24.8344L28.7604 20.2824L30.7565 19.2326L35.496 16.7265L36.2718 15.4875L30.4254 18.5801L28.4009 19.6487L23.2734 22.363Z",
    fill: "url(#paint168_radial_578_447519)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2728 15.4875L35.4971 16.7265V27.9994L36.2728 29.2289V15.4875Z",
    fill: "url(#paint169_radial_578_447519)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8507 23.6112L36.2535 24.6894L36.263 21.3415L33.8223 19.6676L33.8507 23.6112Z",
    fill: "url(#paint170_radial_578_447519)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5236 18.7599L33.5197 17.7102L33.1886 17.0576L31.1641 18.1357L31.5236 18.7599Z",
    fill: "url(#paint171_radial_578_447519)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4966 27.9996V16.7266L31.353 18.9112L24.835 22.3631L29.2056 24.6801L35.4966 27.9996Z",
    fill: "url(#paint172_radial_578_447519)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5283 23.2333C26.5283 23.2333 30.1989 25.0113 34.7871 27.6971C34.7871 27.6877 30.4638 25.5976 26.5283 23.2333Z",
    fill: "url(#paint173_radial_578_447519)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0957 21.143C27.0957 21.143 30.7379 18.9679 35.5248 16.6981C35.5342 16.6981 32.3272 18.4572 27.0957 21.143Z",
    fill: "url(#paint174_radial_578_447519)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4871 28.5292C35.4871 28.5292 35.3358 23.4601 35.5723 17.0292C35.5628 17.0386 35.5912 21.4268 35.4871 28.5292Z",
    fill: "url(#paint175_radial_578_447519)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3115 22.3349C23.3115 22.3349 23.8508 22.2308 24.5887 22.3916C24.5887 22.3822 24.4373 22.5335 23.3115 22.3349Z",
    fill: "url(#paint176_radial_578_447519)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5889 22.382H35.3735L35.4965 27.9995L24.5889 22.382Z",
    fill: "url(#paint177_radial_578_447519)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1506 19.0621L35.7143 19.3458L35.8089 19.1567L35.317 18.977C35.3453 18.0218 35.5724 16.5276 36.5846 15.3549L37.0387 14.6172L36.2535 14.0404L32.2234 11.0519L32.1572 11.3072C32.1667 11.3072 33.7087 16.0358 33.1506 19.0621Z",
    fill: "url(#paint178_radial_578_447519)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1508 19.0623L33.6049 18.3247C34.8253 18.2206 35.7903 15.601 36.2633 14.0311L32.2332 11.0426L32.167 11.298C32.167 11.3074 33.709 16.036 33.1508 19.0623Z",
    fill: "url(#paint179_radial_578_447519)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6963 12.2249C33.226 13.7097 33.9734 16.301 33.6045 18.3343L35.8087 19.157C35.8087 19.157 35.6573 18.06 35.9695 16.7833C36.1398 16.0645 36.4614 15.2795 37.048 14.6175L32.2422 11.0427C32.2422 11.0427 32.4408 11.4967 32.6963 12.2249Z",
    fill: "url(#paint180_radial_578_447519)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8087 19.157L33.6896 18.391L33.1504 19.0625L33.6234 18.2681C33.6234 18.2681 33.8031 17.3602 33.6896 16.6698C33.6896 16.6698 33.8032 17.9371 33.7275 18.2302L35.8087 19.157Z",
    fill: "url(#paint181_radial_578_447519)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6897 16.5468C33.6897 16.5468 33.6708 14.4757 32.6396 12.083C32.6396 12.083 33.4911 14.6176 33.6897 16.5468Z",
    fill: "url(#paint182_radial_578_447519)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2422 11.0427C32.2422 11.0427 32.4408 11.4967 32.7057 12.2154C34.0585 13.6907 35.7046 16.3388 35.979 16.7833C36.1493 16.0645 36.4709 15.2795 37.0574 14.6175L32.2422 11.0427Z",
    fill: "url(#paint183_radial_578_447519)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M35.43 26.0039L35.6192 25.8053L37.0099 29.7395L36.9058 29.7868L33.8975 28.7749L35.43 26.0039Z",
    fill: "url(#paint184_radial_578_447519)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3418 28.4629L37.0096 29.7396L36.6596 28.7466L35.6189 25.8054L35.0608 26.9592L34.3418 28.4629Z",
    fill: "url(#paint185_radial_578_447519)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3421 28.4628L33.8975 28.7748L36.9058 29.7868L37.0099 29.7395L34.3421 28.4628Z",
    fill: "url(#paint186_radial_578_447519)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9475 27.1862L34.4083 28.4818L36.272 29.3991L34.361 28.548L33.8975 28.775L34.3137 28.4534L34.9475 27.1862Z",
    fill: "url(#paint187_radial_578_447519)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0615 26.9592C35.667 27.5929 36.2914 28.3211 36.6603 28.7372L35.6291 25.796L35.0615 26.9592Z",
    fill: "url(#paint188_radial_578_447519)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8574 23.0661L35.1082 22.9033L35.5894 27.427L35.467 27.4509L32.5321 25.6178L34.8574 23.0661Z",
    fill: "url(#paint189_radial_578_447519)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0827 25.3992L35.5895 27.4271L35.4691 26.2856L35.1084 22.9034L34.225 23.986L33.0827 25.3992Z",
    fill: "url(#paint190_radial_578_447519)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0819 25.3991L32.5315 25.6177L35.4664 27.4508L35.5887 27.4269L33.0819 25.3991Z",
    fill: "url(#paint191_radial_578_447519)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0473 24.1981L33.1481 25.436L34.8929 26.8796L33.0812 25.4942L32.5323 25.6179L33.0549 25.382L34.0473 24.1981Z",
    fill: "url(#paint192_radial_578_447519)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2247 23.9861C34.7068 24.811 35.1851 25.7411 35.4712 26.2756L35.1205 22.8958L34.2247 23.9861Z",
    fill: "url(#paint193_radial_578_447519)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3854 17.7602L34.9509 17.5106L36.7544 25.5523L36.4704 25.5761L29.2988 21.9101L34.3854 17.7602Z",
    fill: "url(#paint194_radial_578_447519)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5599 21.6069L36.7542 25.5525L36.3015 23.5233L34.9507 17.5108L33.035 19.2869L30.5599 21.6069Z",
    fill: "url(#paint195_radial_578_447519)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5597 21.6067L29.2985 21.9101L36.4701 25.5761L36.7541 25.5523L30.5597 21.6067Z",
    fill: "url(#paint196_radial_578_447519)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6485 19.6342L30.719 21.6815L35.0351 24.4844L30.5704 21.7742L29.2984 21.9104L30.4919 21.5725L32.6485 19.6342Z",
    fill: "url(#paint197_radial_578_447519)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0357 19.2872C34.2916 20.8123 35.5541 22.522 36.3063 23.5063L34.9794 17.4995L33.0357 19.2872Z",
    fill: "url(#paint198_radial_578_447519)"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7952 17.7602L58.2298 17.5106L56.4262 25.5523L56.7102 25.5761L63.8819 21.9101L58.7952 17.7602Z",
    fill: "url(#paint199_radial_578_447519)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6208 21.6069L56.4264 25.5525L56.8792 23.5233L58.23 17.5108L60.1456 19.2869L62.6208 21.6069Z",
    fill: "url(#paint200_radial_578_447519)"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6209 21.6067L63.8822 21.9101L56.7105 25.5761L56.4265 25.5523L62.6209 21.6067Z",
    fill: "url(#paint201_radial_578_447519)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5321 19.6342L62.4617 21.6815L58.1455 24.4844L62.6103 21.7742L63.8823 21.9104L62.6887 21.5725L60.5321 19.6342Z",
    fill: "url(#paint202_radial_578_447519)"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M60.145 19.2872C58.8891 20.8123 57.6266 22.522 56.8744 23.5063L58.2013 17.4995L60.145 19.2872Z",
    fill: "url(#paint203_radial_578_447519)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3574 23.0661L58.1066 22.9033L57.6255 27.427L57.7478 27.4509L60.6827 25.6178L58.3574 23.0661Z",
    fill: "url(#paint204_radial_578_447519)"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1322 25.3992L57.6254 27.4271L57.7458 26.2856L58.1065 22.9034L58.9899 23.986L60.1322 25.3992Z",
    fill: "url(#paint205_radial_578_447519)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1329 25.3991L60.6833 25.6177L57.7484 27.4508L57.6261 27.4269L60.1329 25.3991Z",
    fill: "url(#paint206_radial_578_447519)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1676 24.1981L60.0667 25.436L58.3219 26.8796L60.1336 25.4942L60.6826 25.6179L60.1599 25.382L59.1676 24.1981Z",
    fill: "url(#paint207_radial_578_447519)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9901 23.9861C58.508 24.811 58.0298 25.7411 57.7436 26.2756L58.0943 22.8958L58.9901 23.9861Z",
    fill: "url(#paint208_radial_578_447519)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1756 21.6065C59.1756 28.5576 53.5373 34.1846 46.5935 34.1846C41.1917 34.1846 36.5751 30.7705 34.7872 25.9852C34.6926 25.7488 34.6169 25.5029 34.5412 25.2475C34.1912 24.0938 34.002 22.8643 34.002 21.5876C34.002 14.9108 39.2051 9.44452 45.7799 9.0284C46.0543 9.00948 46.3192 9 46.5935 9C52.1088 9 56.8011 12.5465 58.504 17.4832C58.9297 18.7883 59.1756 20.1785 59.1756 21.6065Z",
    fill: "url(#paint209_radial_578_447519)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1756 21.6065C59.1756 28.5576 53.5373 34.1846 46.5935 34.1846C41.1917 34.1846 36.5751 30.7705 34.7872 25.9852C34.6926 25.7488 34.6169 25.5029 34.5412 25.2475C34.1912 24.0938 34.002 22.8643 34.002 21.5876C34.002 14.9108 39.2051 9.44452 45.7799 9.0284C46.0543 9.00948 46.3192 9 46.5935 9C52.1088 9 56.8011 12.5465 58.504 17.4832C58.9297 18.7883 59.1756 20.1785 59.1756 21.6065Z",
    fill: "url(#paint210_radial_578_447519)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1756 21.6065C59.1756 28.5576 53.5373 34.1846 46.5935 34.1846C41.1917 34.1846 36.5751 30.7705 34.7872 25.9852C34.6926 25.7488 34.6169 25.5029 34.5412 25.2475C34.1912 24.0938 34.002 22.8643 34.002 21.5876C34.002 14.9108 39.2051 9.44452 45.7799 9.0284C46.0543 9.00948 46.3192 9 46.5935 9C52.1088 9 56.8011 12.5465 58.504 17.4832C58.9297 18.7883 59.1756 20.1785 59.1756 21.6065Z",
    fill: "url(#paint211_radial_578_447519)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5846 9.01892C46.3103 9.01892 46.0359 9.02836 45.7711 9.04727C42.4789 9.25533 39.5273 10.7307 37.4082 13.0004C39.48 11.0522 42.2045 9.80384 45.2224 9.60524C45.4967 9.58633 45.7616 9.57689 46.0359 9.57689C52.9892 9.57689 58.618 15.2134 58.618 22.155C58.618 25.4934 57.322 28.5197 55.2029 30.7705C57.6436 28.4819 59.1762 25.2097 59.1762 21.597C59.1762 14.6649 53.5379 9.01892 46.5846 9.01892Z",
    fill: "url(#paint212_radial_578_447519)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5846 30.7799C51.6526 30.7799 55.761 26.6728 55.761 21.6064C55.761 16.54 51.6526 12.4329 46.5846 12.4329C41.5166 12.4329 37.4082 16.54 37.4082 21.6064C37.4082 26.6728 41.5166 30.7799 46.5846 30.7799Z",
    fill: "url(#paint213_linear_578_447519)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5843 29.5503C50.9731 29.5503 54.5309 25.9936 54.5309 21.6062C54.5309 17.2188 50.9731 13.6621 46.5843 13.6621C42.1955 13.6621 38.6377 17.2188 38.6377 21.6062C38.6377 25.9936 42.1955 29.5503 46.5843 29.5503Z",
    fill: "url(#paint214_radial_578_447519)"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6004 19.9039C55.6666 20.339 55.695 20.7835 55.695 21.2279C55.695 26.297 51.5892 30.4015 46.5185 30.4015C42.0344 30.4015 38.307 27.186 37.5029 22.9397C38.1462 27.3751 41.9682 30.7797 46.5753 30.7797C51.646 30.7797 55.7517 26.6753 55.7517 21.6062C55.7612 21.0293 55.7044 20.4524 55.6004 19.9039Z",
    fill: "url(#paint215_radial_578_447519)"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6729 22.9399C37.6067 22.5049 37.5783 22.0604 37.5783 21.6159C37.5783 16.5468 41.684 12.4424 46.7547 12.4424C51.2389 12.4424 54.9662 15.6579 55.7703 19.9042C55.127 15.4687 51.3051 12.0641 46.698 12.0641C41.6273 12.0641 37.5215 16.1685 37.5215 21.2376C37.5121 21.8239 37.5688 22.3914 37.6729 22.9399Z",
    fill: "url(#paint216_radial_578_447519)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2091 32.9364C41.8073 32.9364 37.1907 29.5223 35.4027 24.7369C35.3081 24.5005 35.2324 24.2546 35.1568 23.9993C34.8067 22.8455 34.6175 21.616 34.6175 20.3393C34.6175 18.5803 34.977 16.9158 35.6203 15.3932C34.5892 17.2279 33.9932 19.3369 33.9932 21.5877C33.9932 22.8644 34.1824 24.0844 34.5324 25.2476C34.6081 25.503 34.6837 25.7394 34.7783 25.9853C36.5569 30.7706 41.1735 34.1847 46.5847 34.1847C51.7784 34.1847 56.2436 31.0354 58.1641 26.5338C56.0071 30.364 51.9108 32.9364 47.2091 32.9364Z",
    fill: "url(#paint217_radial_578_447519)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2409 21.5403C54.3989 22.8075 53.4718 24.0086 52.4596 25.134C52.4028 25.2002 52.3366 25.2664 52.2893 25.3326C51.9866 25.6636 51.6744 25.9851 51.3622 26.3067C50.6243 27.0444 49.8485 27.7442 49.0444 28.4062C48.2592 29.0399 47.4456 29.6451 46.6037 30.1936C45.3171 29.3425 44.1062 28.4062 42.971 27.3754C41.1262 25.7109 39.4896 23.8289 38.0989 21.7578C38.0516 21.6916 38.0043 21.6159 37.957 21.5403C38.43 20.831 38.9314 20.1406 39.4518 19.4691C40.1991 18.5234 40.9938 17.625 41.8546 16.7738C42.2993 16.3293 42.7628 15.8943 43.2358 15.4782C44.2954 14.5419 45.4212 13.6719 46.6131 12.8964C47.4929 13.4827 48.3444 14.1163 49.1674 14.7878C49.9337 15.4214 50.681 16.0834 51.3811 16.7927C52.7907 18.2208 54.1056 19.819 55.2409 21.5403Z",
    fill: "url(#paint218_radial_578_447519)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2401 21.5401H46.584V12.8867C48.3057 14.0216 49.8951 15.3267 51.3425 16.7831C52.7899 18.2301 54.1049 19.8189 55.2401 21.5401Z",
    fill: "url(#paint219_radial_578_447519)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5848 12.8868V21.5402H37.9287C39.0639 19.819 40.3694 18.2302 41.8263 16.7832C43.2737 15.3268 44.8631 14.0217 46.5848 12.8868Z",
    fill: "url(#paint220_radial_578_447519)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5848 21.5403V30.1936C43.1508 27.9239 40.2086 24.9827 37.9287 21.5403H46.5848Z",
    fill: "url(#paint221_radial_578_447519)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2401 21.5403C54.1049 23.2615 52.7994 24.8503 51.3425 26.2972C49.8856 27.7442 48.3057 29.0493 46.584 30.1936V21.5403H55.2401Z",
    fill: "url(#paint222_radial_578_447519)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2404 21.54C54.1052 23.2612 52.7996 24.85 51.3428 26.297C49.8859 27.7439 48.306 29.049 46.5843 30.1934C45.2977 29.3422 44.8247 29.0585 43.6895 28.0277L49.1291 14.7781C49.8954 15.4117 50.6427 16.0737 51.3428 16.783C52.7902 18.2205 54.1052 19.8188 55.2404 21.54Z",
    fill: "url(#paint223_radial_578_447519)"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2792 25.3233C51.9765 25.6543 51.6643 25.9759 51.3521 26.2974C49.9047 27.7444 48.3154 29.0495 46.5936 30.1938C45.307 29.3426 44.0961 28.4064 42.9609 27.3756C41.1161 25.7111 39.4795 23.8291 38.0889 21.7579C41.6838 22.8266 46.972 24.3019 52.2792 25.3233Z",
    fill: "url(#paint224_radial_578_447519)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4599 25.1338C52.4031 25.2 52.3369 25.2662 52.2896 25.3324C51.9869 25.6634 51.6747 25.985 51.3625 26.3065C50.6246 27.0442 49.8489 27.744 49.0447 28.406C47.0108 24.7934 44.7404 20.4525 44.5606 18.7502C44.5417 18.7313 49.0448 22.4574 52.4599 25.1338Z",
    fill: "url(#paint225_radial_578_447519)"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5852 21.5404L39.4238 19.4692C40.1712 18.5235 40.9658 17.6251 41.8267 16.7739C42.2713 16.3294 42.7349 15.8944 43.2079 15.4783L46.5852 21.5404Z",
    fill: "url(#paint226_radial_578_447519)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5847 27.234C44.3237 25.7397 42.3844 23.7915 40.8896 21.5407C42.3844 19.2804 44.3332 17.3417 46.5847 15.8474C48.8457 17.3417 50.785 19.2899 52.2798 21.5407C50.785 23.801 48.8552 25.7397 46.5847 27.234Z",
    fill: "url(#paint227_radial_578_447519)"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4234 19.8758C40.1708 18.9301 40.9654 18.0317 41.8263 17.1805C42.271 16.736 42.7345 16.301 43.2075 15.8849C44.2671 14.9486 45.3928 14.0786 46.5848 13.3031C47.4646 13.8894 48.316 14.523 49.1391 15.1945C49.9054 15.8281 50.6527 16.4902 51.3528 17.1995C52.7434 18.5897 54.0017 20.1123 55.1085 21.7578C55.1558 21.6916 55.2031 21.6255 55.2504 21.5593C54.1152 19.838 52.8097 18.2492 51.3528 16.8022C50.6433 16.0929 49.9148 15.431 49.1391 14.7973C48.3255 14.1259 47.4741 13.5017 46.5848 12.9059C45.3928 13.6908 44.2671 14.5514 43.2075 15.4877C42.7345 15.9038 42.271 16.3389 41.8263 16.7833C40.9749 17.6345 40.1803 18.5329 39.4234 19.4787C38.9031 20.1407 38.3923 20.831 37.9287 21.5498C37.9666 21.616 38.0233 21.6917 38.0706 21.7484C38.4963 21.1053 38.9504 20.4811 39.4234 19.8758Z",
    fill: "url(#paint228_radial_578_447519)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M52.4596 24.7084C52.4028 24.7746 52.3366 24.8408 52.2893 24.907C51.9866 25.238 51.6744 25.5595 51.3622 25.8811C50.6243 26.6188 49.8485 27.3186 49.0444 27.9806C48.2592 28.6143 47.4456 29.2195 46.6037 29.768C45.3171 28.9169 44.1062 27.9806 42.971 26.9498C41.1262 25.2853 39.4896 23.4033 38.0989 21.3322C38.0516 21.3984 38.0043 21.474 37.957 21.5402C38.0043 21.6064 38.0516 21.6821 38.0989 21.7577C39.4896 23.8289 41.1357 25.7109 42.971 27.3754C44.1062 28.4062 45.3171 29.3424 46.6037 30.1936C47.4456 29.6356 48.2592 29.0398 49.0444 28.4062C49.858 27.7536 50.6337 27.0538 51.3622 26.3067C51.6744 25.9851 51.996 25.6636 52.2893 25.3326C52.3555 25.2664 52.4123 25.2002 52.4596 25.134C53.4718 24.0086 54.3989 22.817 55.2409 21.5402C55.1936 21.474 55.1463 21.3984 55.099 21.3322C54.2948 22.5143 53.4151 23.6492 52.4596 24.7084Z",
    fill: "url(#paint229_radial_578_447519)"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M46.584 15.8373C46.584 15.8373 49.9613 17.9557 52.279 21.5305C52.2885 21.54 50.614 17.8233 46.584 15.8373Z",
    fill: "url(#paint230_radial_578_447519)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8896 21.5403C40.8896 21.5403 42.9141 25.0678 46.3198 27.1957L46.5942 29.7775L46.7834 27.1579C46.7834 27.1579 49.3187 26.0798 52.2892 21.5497C52.2892 21.5497 48.5241 26.5715 46.528 26.8647C46.528 26.8552 44.1913 25.9474 40.8896 21.5403Z",
    fill: "url(#paint231_radial_578_447519)"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6035 27.2143C46.6035 27.2143 50.1322 25.1905 52.2607 21.7859L54.8434 21.5116L52.2229 21.3225C52.2229 21.3225 51.1444 18.7879 46.613 15.8184C46.613 15.8184 51.6364 19.5823 51.9296 21.5778C51.9391 21.5683 51.0214 23.9043 46.6035 27.2143Z",
    fill: "url(#paint232_radial_578_447519)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4713 15.8093C46.4713 15.8093 42.9426 17.8332 40.8141 21.2378L38.2314 21.5121L40.8519 21.7012C40.8519 21.7012 41.9304 24.2357 46.4618 27.2053C46.4618 27.2053 41.4385 23.4413 41.1452 21.4458C41.1452 21.4553 42.0534 19.1194 46.4713 15.8093Z",
    fill: "url(#paint233_radial_578_447519)"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M52.2892 21.4929C52.2892 21.4929 50.2647 17.9653 46.8591 15.8375L46.5847 13.2556L46.3955 15.8753C46.3955 15.8753 43.8602 16.9534 40.8896 21.4834C40.8896 21.4834 44.6548 16.4616 46.6509 16.1685C46.6509 16.1685 48.9781 17.0763 52.2892 21.4929Z",
    fill: "url(#paint234_radial_578_447519)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6583 32.1987C52.6488 32.1987 53.4908 31.461 53.7368 30.5248C53.7651 30.4113 53.7841 30.2978 53.7935 30.1843C53.8976 28.917 55.2598 28.9359 55.2125 29.475C55.0044 32.1514 52.7907 32.1987 52.6583 32.1987Z",
    fill: "url(#paint235_radial_578_447519)"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2216 29.4751C54.5688 29.0968 54.0864 30.3074 54.0864 30.3074L53.7363 30.5344C53.7647 30.4209 53.7836 30.3074 53.7931 30.1939C53.8971 28.9172 55.2594 28.9361 55.2216 29.4751Z",
    fill: "url(#paint236_radial_578_447519)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6582 32.199C52.696 32.1896 53.6799 31.8775 53.9921 30.6575C54.3232 29.4091 54.7678 29.1727 55.2125 29.4753C55.0043 32.1517 52.7906 32.199 52.6582 32.199Z",
    fill: "url(#paint237_radial_578_447519)"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6582 32.1989C52.696 32.1895 53.6988 31.7639 54.0394 30.5533C54.3232 29.5225 54.7773 29.1537 55.2219 29.4752C55.0043 32.1516 52.7906 32.1989 52.6582 32.1989Z",
    fill: "url(#paint238_radial_578_447519)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0391 30.5436C54.0391 30.5436 54.3418 29.3141 54.9662 29.3709C54.9756 29.3709 54.3229 28.9264 54.0391 30.5436Z",
    fill: "url(#paint239_radial_578_447519)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6165 29.8534C54.6165 29.844 54.626 29.8251 54.626 29.8156C54.6354 29.8062 54.6354 29.7873 54.626 29.7778C54.626 29.7683 54.6165 29.7494 54.6165 29.74C54.6071 29.7305 54.6071 29.721 54.5882 29.7116C54.5787 29.7021 54.5692 29.7022 54.5503 29.6927C54.5409 29.6927 54.5314 29.6927 54.522 29.6832C54.5031 29.6832 54.4841 29.6927 54.4652 29.6927C54.4558 29.7022 54.4558 29.7021 54.4463 29.7021C54.4368 29.7116 54.4274 29.7305 54.4179 29.7494C54.4179 29.7589 54.4085 29.7778 54.4085 29.7873C54.399 29.7967 54.399 29.8156 54.4085 29.8251C54.4085 29.8345 54.4179 29.8534 54.4179 29.8629C54.4274 29.8724 54.4274 29.8818 54.4463 29.8913C54.4558 29.9007 54.4652 29.9007 54.4841 29.9102C54.4936 29.9102 54.503 29.9102 54.5125 29.9197C54.5314 29.9197 54.5503 29.9102 54.5693 29.9102C54.5787 29.9007 54.5787 29.9007 54.5882 29.9007C54.5976 29.8913 54.6165 29.8724 54.6165 29.8534Z",
    fill: "url(#paint240_radial_578_447519)"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7612 31.3003C54.73 31.3665 53.8691 32.3217 53.8691 32.3217C53.8691 32.3217 53.8691 32.3217 53.8691 32.3122C53.8786 32.1798 53.9637 30.1465 56.4423 29.9952C56.641 29.9857 56.764 30.1844 56.7545 30.4302C56.745 30.7896 56.4612 31.2436 55.7612 31.3003Z",
    fill: "url(#paint241_radial_578_447519)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7612 31.3C54.73 31.3662 53.8691 32.3213 53.8691 32.3213C53.8691 32.3213 53.8691 32.3213 53.8691 32.3119C53.8786 32.2173 53.9732 31.3472 54.9287 31.0257C55.7233 30.7609 56.395 30.6663 56.7545 30.4204C56.7451 30.7892 56.4612 31.2432 55.7612 31.3Z",
    fill: "url(#paint242_radial_578_447519)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M55.7612 31.3C54.73 31.3662 53.8691 32.3213 53.8691 32.3213C53.8691 32.3213 53.8691 32.3213 53.8691 32.3119C53.8786 32.2173 53.9732 31.3472 54.9287 31.0257C55.7233 30.7609 56.395 30.6663 56.7545 30.4204C56.7451 30.7892 56.4612 31.2432 55.7612 31.3Z",
    fill: "url(#paint243_radial_578_447519)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3516 31.3569C54.3516 31.3569 54.5786 30.8841 55.7895 30.7706C55.7801 30.7706 54.8246 30.9408 54.3516 31.3569Z",
    fill: "url(#paint244_radial_578_447519)"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1445 33.0878C51.1445 33.0878 52.0906 32.1326 52.2041 31.0261C52.2136 30.9599 52.2135 30.9032 52.2135 30.837C52.223 29.7021 53.2447 29.4563 53.5758 29.74C53.642 29.7967 53.6799 29.8724 53.6799 29.9669C53.6799 30.0048 53.6799 30.0615 53.6799 30.0993C53.6799 30.1372 53.6799 30.175 53.6704 30.2128C53.6704 30.2601 53.661 30.3074 53.661 30.3547C53.6515 30.3925 53.6515 30.4303 53.6515 30.4776C53.3582 32.9176 51.2108 33.0784 51.1445 33.0878Z",
    fill: "url(#paint245_radial_578_447519)"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1445 33.0876C51.1918 33.0498 52.2703 32.3405 52.469 31.007C52.6014 30.0707 53.1028 29.7681 53.5853 29.7397C53.6515 29.7965 53.6893 29.8721 53.6893 29.9667C53.6515 32.8985 51.2108 33.0781 51.1445 33.0876Z",
    fill: "url(#paint246_radial_578_447519)"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1445 33.0876C51.1918 33.0498 52.2703 32.3405 52.469 31.007C52.6014 30.0707 53.1028 29.7681 53.5853 29.7397C53.6515 29.7965 53.6893 29.8721 53.6893 29.9667C53.6515 32.8985 51.2108 33.0781 51.1445 33.0876Z",
    fill: "url(#paint247_radial_578_447519)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5758 29.7395C53.1217 29.7679 52.6487 30.0421 52.4879 30.8838C52.3365 30.95 52.2514 30.9973 52.2041 31.0257C52.2136 30.9595 52.2135 30.9027 52.2135 30.8365C52.223 29.6922 53.2447 29.4464 53.5758 29.7395Z",
    fill: "url(#paint248_radial_578_447519)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2646 29.7583C53.2646 29.7583 52.4983 29.9096 52.3848 31.4038C52.3848 31.4038 52.5645 30.2312 53.2646 29.7583Z",
    fill: "url(#paint249_radial_578_447519)"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9037 32.3125C55.6956 32.6908 55.2226 33.0218 54.4658 32.9083C53.1508 32.7003 51.7791 33.646 51.7412 33.6743C51.7412 33.6743 52.3845 30.9034 55.724 31.433C56.0645 31.4803 56.1213 31.9153 55.9037 32.3125Z",
    fill: "url(#paint250_radial_578_447519)"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9037 32.3123C55.6956 32.6906 55.2226 33.0216 54.4658 32.9081C53.1508 32.7001 51.7791 33.6457 51.7412 33.6741C51.7791 33.6363 53.2265 31.3855 55.9037 32.3123Z",
    fill: "url(#paint251_radial_578_447519)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9037 32.3123C55.6956 32.6906 55.2226 33.0216 54.4658 32.9081C53.1508 32.7001 51.7791 33.6457 51.7412 33.6741C51.7791 33.6363 53.2265 31.3855 55.9037 32.3123Z",
    fill: "url(#paint252_radial_578_447519)"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5645 32.8138C52.5645 32.8138 53.747 31.5844 55.6296 32.1802C55.6296 32.1802 53.9456 31.8587 52.5645 32.8138Z",
    fill: "url(#paint253_radial_578_447519)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5898 34.9793C48.5898 34.9793 52.0523 34.6766 51.9766 30.5722C51.9672 29.7778 49.9521 29.948 49.9805 31.83C50.0089 33.4661 48.5898 34.9793 48.5898 34.9793Z",
    fill: "url(#paint254_radial_578_447519)"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5996 34.9887C48.5996 34.9887 48.6091 34.9792 48.6374 34.9508C48.855 34.7049 50.0092 33.3147 49.9713 31.8299C49.9619 31.5367 50.0092 31.2814 50.0943 31.0639C50.1416 30.922 50.2173 30.8085 50.293 30.695C50.8417 29.9195 51.9485 29.9668 51.9675 30.5532C52.0621 34.6387 48.6469 34.9792 48.5996 34.9887Z",
    fill: "url(#paint255_radial_578_447519)"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M48.8834 34.7803C48.7887 34.8465 48.7036 34.9033 48.6279 34.9317C48.8455 34.6858 50.0091 33.305 49.9807 31.8108C49.9713 31.319 50.1037 30.9502 50.2929 30.6759C50.2645 31.1677 50.2835 31.754 50.4443 32.2552C50.4443 32.2552 51.1443 31.2812 51.2673 30.7137C51.2673 30.7326 51.1065 33.2577 48.8834 34.7803Z",
    fill: "url(#paint256_radial_578_447519)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9679 30.5627C51.3246 29.8439 50.4258 30.6951 50.0947 31.0545C50.142 30.9126 50.2177 30.7991 50.2934 30.6951C50.8515 29.9196 51.9584 29.9763 51.9679 30.5627Z",
    fill: "url(#paint257_radial_578_447519)"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2496 34.2985C54.9184 34.8849 54.1143 35.4239 52.9412 34.8565C51.21 34.0242 48.9396 34.7714 48.8828 34.7903C48.9207 34.7241 50.9357 31.2628 55.2685 33.3339C55.4955 33.4379 55.4861 33.8824 55.2496 34.2985Z",
    fill: "url(#paint258_radial_578_447519)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2496 34.2981C54.9184 34.8844 54.1143 35.4235 52.9412 34.8561C51.21 34.0238 48.9396 34.771 48.8828 34.7899C50.9546 32.7755 53.7359 33.5983 55.2496 34.2981Z",
    fill: "url(#paint259_radial_578_447519)"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2496 34.2981C54.9184 34.8844 54.1143 35.4235 52.9412 34.8561C51.21 34.0238 48.9396 34.771 48.8828 34.7899C50.9546 32.7755 53.7359 33.5983 55.2496 34.2981Z",
    fill: "url(#paint260_radial_578_447519)"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7002 33.6836C50.7002 33.6836 52.6395 33.3147 54.4654 34.0051C54.4654 34.0051 52.6301 32.9081 50.7002 33.6836Z",
    fill: "url(#paint261_radial_578_447519)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4056 36.2083C53.0177 36.8041 51.8351 37.2486 50.7188 36.2178C49.2903 34.9033 46.8496 34.9694 46.8496 34.9694C46.9064 34.9221 49.8485 32.189 53.3866 35.4423C53.6042 35.6409 53.5853 35.9435 53.4056 36.2083Z",
    fill: "url(#paint262_radial_578_447519)"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4056 36.2082C53.0177 36.804 51.8351 37.2485 50.7188 36.2176C49.2903 34.9031 46.8496 34.9693 46.8496 34.9693C46.9158 34.9314 49.9242 33.2008 53.4056 36.2082Z",
    fill: "url(#paint263_radial_578_447519)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4056 36.2082C53.0177 36.804 51.8351 37.2485 50.7188 36.2176C49.2903 34.9031 46.8496 34.9693 46.8496 34.9693C46.9158 34.9314 49.9242 33.2008 53.4056 36.2082Z",
    fill: "url(#paint264_radial_578_447519)"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8496 34.9699C46.8496 34.9699 49.7917 33.4473 53.4056 36.2088C53.4056 36.2088 50.6432 33.069 46.8496 34.9699Z",
    fill: "url(#paint265_radial_578_447519)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5115 32.1987C40.521 32.1987 40.521 32.1987 40.5115 32.1987C40.521 32.1987 39.679 31.461 39.4331 30.5248C39.4047 30.4113 39.3858 30.2978 39.3763 30.1843C39.2722 28.917 37.91 28.9359 37.9573 29.475C38.1654 32.1514 40.3885 32.1987 40.5115 32.1987Z",
    fill: "url(#paint266_radial_578_447519)"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9471 29.475C38.5998 29.0967 39.0823 30.3073 39.0823 30.3073L39.4323 30.5342C39.404 30.4207 39.385 30.3072 39.3756 30.1938C39.2715 28.917 37.9092 28.936 37.9471 29.475Z",
    fill: "url(#paint267_radial_578_447519)"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5103 32.1989C40.5198 32.1989 40.5198 32.1989 40.5103 32.1989C40.4725 32.1895 39.4886 31.8774 39.1764 30.6574C38.8453 29.409 38.4007 29.1726 37.9561 29.4752C38.1642 32.1516 40.3873 32.1989 40.5103 32.1989Z",
    fill: "url(#paint268_radial_578_447519)"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M40.511 32.1988C40.5205 32.1988 40.5205 32.1988 40.511 32.1988C40.4732 32.1894 39.4704 31.7638 39.1298 30.5532C38.846 29.5224 38.3919 29.1536 37.9473 29.4751C38.1649 32.1515 40.388 32.1988 40.511 32.1988Z",
    fill: "url(#paint269_radial_578_447519)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1293 30.5436C39.1293 30.5436 38.8266 29.3141 38.2022 29.3709C38.1928 29.3709 38.855 28.9264 39.1293 30.5436Z",
    fill: "url(#paint270_radial_578_447519)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7699 29.7966C38.7699 29.7871 38.7604 29.7682 38.7604 29.7587C38.7604 29.7493 38.7509 29.7304 38.7415 29.7209C38.732 29.7115 38.7226 29.702 38.7131 29.6926C38.7036 29.6831 38.6847 29.6831 38.6753 29.6831C38.6658 29.6831 38.6469 29.6831 38.6374 29.6831C38.628 29.6926 38.6185 29.6926 38.6091 29.6926C38.5996 29.702 38.5807 29.7115 38.5712 29.7304C38.5618 29.7398 38.5618 29.7493 38.5618 29.7587C38.5523 29.7777 38.5523 29.7966 38.5618 29.8155C38.5618 29.825 38.5712 29.8439 38.5712 29.8533C38.5712 29.8628 38.5807 29.8817 38.5902 29.8911C38.5996 29.9006 38.6091 29.9101 38.6185 29.9195C38.628 29.929 38.6469 29.929 38.6564 29.929C38.6658 29.929 38.6847 29.929 38.6942 29.929C38.7037 29.9195 38.7131 29.9195 38.7226 29.9195C38.732 29.9101 38.7509 29.9006 38.7604 29.8817C38.7698 29.8723 38.7699 29.8628 38.7699 29.8533C38.7793 29.8439 38.7793 29.8249 38.7699 29.7966Z",
    fill: "url(#paint271_radial_578_447519)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4177 31.3003C38.4488 31.3665 39.3097 32.3217 39.3097 32.3217C39.3097 32.3217 39.3097 32.3217 39.3097 32.3122C39.3002 32.1798 39.2151 30.1465 36.7365 29.9952C36.5379 29.9857 36.4149 30.1844 36.4243 30.4302C36.4243 30.7896 36.7176 31.2436 37.4177 31.3003Z",
    fill: "url(#paint272_radial_578_447519)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4181 31.3C38.4493 31.3662 39.3102 32.3213 39.3102 32.3213C39.3102 32.3213 39.3102 32.3213 39.3102 32.3119C39.3007 32.2173 39.2061 31.3472 38.2506 31.0257C37.456 30.7609 36.7843 30.6663 36.4248 30.4204C36.4248 30.7892 36.7181 31.2432 37.4181 31.3Z",
    fill: "url(#paint273_radial_578_447519)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4181 31.3C38.4493 31.3662 39.3102 32.3213 39.3102 32.3213C39.3102 32.3213 39.3102 32.3213 39.3102 32.3119C39.3007 32.2173 39.2061 31.3472 38.2506 31.0257C37.456 30.7609 36.7843 30.6663 36.4248 30.4204C36.4248 30.7892 36.7181 31.2432 37.4181 31.3Z",
    fill: "url(#paint274_radial_578_447519)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8276 31.3569C38.8276 31.3569 38.6006 30.8841 37.3896 30.7706C37.3896 30.7706 38.3546 30.9408 38.8276 31.3569Z",
    fill: "url(#paint275_radial_578_447519)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0256 33.0877C42.0256 33.0877 41.0796 32.1325 40.966 31.026C40.9566 30.9598 40.9566 30.9031 40.9566 30.8369C40.9471 29.702 39.9254 29.4561 39.5943 29.7399C39.5281 29.7966 39.4902 29.8722 39.4902 29.9668C39.4902 30.0046 39.4902 30.0614 39.4902 30.0992C39.4902 30.137 39.4902 30.1749 39.4997 30.2127C39.4997 30.26 39.5092 30.3073 39.5092 30.3546C39.5186 30.3924 39.5186 30.4302 39.5186 30.4775C39.8119 32.9175 41.9688 33.0782 42.0256 33.0877Z",
    fill: "url(#paint276_radial_578_447519)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0253 33.0874C41.978 33.0495 40.8995 32.3402 40.7008 31.0068C40.5684 30.0705 40.067 29.7679 39.5845 29.7395C39.5183 29.7962 39.4805 29.8719 39.4805 29.9665C39.5278 32.8982 41.959 33.0779 42.0253 33.0874Z",
    fill: "url(#paint277_radial_578_447519)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0253 33.0874C41.978 33.0495 40.8995 32.3402 40.7008 31.0068C40.5684 30.0705 40.067 29.7679 39.5845 29.7395C39.5183 29.7962 39.4805 29.8719 39.4805 29.9665C39.5278 32.8982 41.959 33.0779 42.0253 33.0874Z",
    fill: "url(#paint278_radial_578_447519)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5938 29.7394C40.0478 29.7678 40.5209 30.042 40.6817 30.8837C40.833 30.9499 40.9182 30.9972 40.9655 31.0256C40.956 30.9594 40.956 30.9026 40.956 30.8364C40.9466 29.6921 39.9343 29.4462 39.5938 29.7394Z",
    fill: "url(#paint279_radial_578_447519)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9062 29.7582C39.9062 29.7582 40.6725 29.9095 40.786 31.4037C40.786 31.4037 40.6063 30.231 39.9062 29.7582Z",
    fill: "url(#paint280_radial_578_447519)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2668 32.3124C37.4749 32.6907 37.948 33.0217 38.7048 32.9082C40.0197 32.7002 41.3915 33.6458 41.4293 33.6742C41.4293 33.6742 40.786 30.9033 37.4466 31.4329C37.1155 31.4802 37.0492 31.9152 37.2668 32.3124Z",
    fill: "url(#paint281_radial_578_447519)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2666 32.3122C37.4747 32.6904 37.9477 33.0215 38.7046 32.908C40.0195 32.6999 41.3913 33.6456 41.4291 33.674C41.4007 33.6362 39.9533 31.3854 37.2666 32.3122Z",
    fill: "url(#paint282_radial_578_447519)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2666 32.3122C37.4747 32.6904 37.9477 33.0215 38.7046 32.908C40.0195 32.6999 41.3913 33.6456 41.4291 33.674C41.4007 33.6362 39.9533 31.3854 37.2666 32.3122Z",
    fill: "url(#paint283_radial_578_447519)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6149 32.8137C40.6149 32.8137 39.4324 31.5843 37.5498 32.1801C37.5498 32.1801 39.2337 31.8585 40.6149 32.8137Z",
    fill: "url(#paint284_radial_578_447519)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5892 34.9792C44.5892 34.9792 41.1267 34.6765 41.2024 30.5721C41.2119 29.7777 43.2269 29.9479 43.1985 31.8299C43.1701 33.466 44.5892 34.9792 44.5892 34.9792Z",
    fill: "url(#paint285_radial_578_447519)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5696 34.9886C44.5696 34.9886 44.5601 34.9792 44.5318 34.9508C44.3142 34.7049 43.16 33.3147 43.1979 31.8299C43.2073 31.5367 43.16 31.2814 43.0749 31.0639C43.0276 30.922 42.9519 30.8085 42.8762 30.695C42.3275 29.9195 41.2207 29.9668 41.2018 30.5532C41.1166 34.6387 44.5223 34.9792 44.5696 34.9886Z",
    fill: "url(#paint286_radial_578_447519)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2955 34.7802C44.3901 34.8464 44.4752 34.9032 44.5509 34.9315C44.3333 34.6856 43.1697 33.3049 43.1981 31.8106C43.2075 31.3189 43.0751 30.95 42.8859 30.6758C42.9143 31.1676 42.8953 31.7539 42.7345 32.2551C42.7345 32.2551 42.0345 31.281 41.9115 30.7136C41.902 30.7325 42.0723 33.2576 44.2955 34.7802Z",
    fill: "url(#paint287_radial_578_447519)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2021 30.5626C41.8454 29.8438 42.7442 30.695 43.0753 31.0544C43.028 30.9125 42.9523 30.799 42.8766 30.695C42.3185 29.9195 41.2211 29.9762 41.2021 30.5626Z",
    fill: "url(#paint288_radial_578_447519)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9198 34.2984C38.2509 34.8847 39.055 35.4238 40.2281 34.8564C41.9593 34.0241 44.2297 34.7713 44.2865 34.7902C44.2487 34.724 42.2336 31.2626 37.9009 33.3338C37.6738 33.4378 37.6833 33.8823 37.9198 34.2984Z",
    fill: "url(#paint289_radial_578_447519)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9189 34.298C38.2501 34.8843 39.0542 35.4234 40.2272 34.856C41.9585 34.0237 44.2289 34.7709 44.2857 34.7898C42.2139 32.7754 39.4326 33.5981 37.9189 34.298Z",
    fill: "url(#paint290_radial_578_447519)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9189 34.298C38.2501 34.8843 39.0542 35.4234 40.2272 34.856C41.9585 34.0237 44.2289 34.7709 44.2857 34.7898C42.2139 32.7754 39.4326 33.5981 37.9189 34.298Z",
    fill: "url(#paint291_radial_578_447519)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4703 33.6835C42.4703 33.6835 40.5309 33.3146 38.7051 34.005C38.7051 34.005 40.5498 32.908 42.4703 33.6835Z",
    fill: "url(#paint292_radial_578_447519)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7736 36.2082C40.1615 36.804 41.344 37.2485 42.4603 36.2177C43.8888 34.9031 46.3295 34.9693 46.3295 34.9693C46.2728 34.922 43.3306 32.1889 39.7925 35.4422C39.5655 35.6408 39.5844 35.9434 39.7736 36.2082Z",
    fill: "url(#paint293_radial_578_447519)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7734 36.2081C40.1613 36.8039 41.3438 37.2484 42.4602 36.2175C43.8886 34.903 46.3294 34.9692 46.3294 34.9692C46.2537 34.9313 43.2453 33.2007 39.7734 36.2081Z",
    fill: "url(#paint294_radial_578_447519)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7734 36.2081C40.1613 36.8039 41.3438 37.2484 42.4602 36.2175C43.8886 34.903 46.3294 34.9692 46.3294 34.9692C46.2537 34.9313 43.2453 33.2007 39.7734 36.2081Z",
    fill: "url(#paint295_radial_578_447519)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3196 34.9698C46.3196 34.9698 43.3775 33.4472 39.7637 36.2087C39.7731 36.2087 42.5355 33.0689 46.3196 34.9698Z",
    fill: "url(#paint296_radial_578_447519)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2594 34.0046V35.2341L47.512 35.811L46.5849 36.5203L44.9199 35.2341V34.0046H48.2594Z",
    fill: "url(#paint297_radial_578_447519)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2692 34.0047V35.2152L46.5853 36.4919L46.5758 36.4825V35.7164L46.4434 34.7707C46.4434 34.7707 46.7839 34.4019 47.1529 33.9952L48.2692 34.0047Z",
    fill: "url(#paint298_radial_578_447519)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5849 35.7448V36.5203L44.9199 35.2341L44.9388 34.0046H46.093L46.5849 35.7448Z",
    fill: "url(#paint299_radial_578_447519)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2594 33.8914V34.9317L46.6417 36.0098L44.9767 34.9033L44.9199 34.856V33.8914H48.2594Z",
    fill: "url(#paint300_radial_578_447519)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5849 35.7448V36.5203L44.9199 35.2341L44.9388 34.0046H46.093L46.5849 35.7448Z",
    fill: "url(#paint301_radial_578_447519)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5852 36.5202C46.5852 36.5202 46.4244 35.5556 46.6136 34.1559C46.6136 34.1559 46.6987 35.2813 46.5852 36.5202Z",
    fill: "url(#paint302_radial_578_447519)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M46.585 30.874L44.5605 34.5907L46.585 35.7445L48.619 34.5907L46.585 30.874Z",
    fill: "url(#paint303_radial_578_447519)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M46.585 30.8741V35.7446L48.6189 34.5908L46.585 30.8741Z",
    fill: "url(#paint304_radial_578_447519)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5945 31.6029C46.5945 31.6029 46.5094 33.2957 46.5945 35.0926C46.5945 35.0926 46.708 33.4849 46.5945 31.6029Z",
    fill: "url(#paint305_radial_578_447519)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6188 34.5912L47.0957 35.4329L48.5337 34.5629L47.5687 32.7281L48.6188 34.5912Z",
    fill: "url(#paint306_radial_578_447519)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M46.585 30.874V35.7445L44.5605 34.5907L46.585 30.874Z",
    fill: "url(#paint307_radial_578_447519)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5605 34.5911L46.585 35.7449L44.7025 34.5438L45.8377 32.293L44.5605 34.5911Z",
    fill: "url(#paint308_radial_578_447519)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M47.172 33.6359C47.1057 33.7493 47.0206 33.8534 46.9165 33.948C46.8219 34.0425 46.7179 34.1276 46.6043 34.2033C46.3868 34.052 46.1976 33.8628 46.0557 33.6264C46.1219 33.5129 46.207 33.4089 46.3111 33.3143C46.4057 33.2198 46.5098 33.1346 46.6233 33.059C46.7368 33.1346 46.8314 33.2198 46.9354 33.3143C47.0111 33.4089 47.0868 33.5224 47.172 33.6359Z",
    fill: "url(#paint309_radial_578_447519)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1719 33.598C47.1057 33.7115 47.0206 33.8155 46.9165 33.9101C46.8125 34.0047 46.7179 34.0898 46.6043 34.1655C46.3868 34.0141 46.1976 33.825 46.0557 33.5886C46.1219 33.4751 46.207 33.3711 46.3111 33.2765C46.4057 33.1819 46.5098 33.0968 46.6233 33.0211C46.7368 33.0968 46.8314 33.1819 46.9354 33.2765C47.0111 33.3805 47.0868 33.4845 47.1719 33.598Z",
    fill: "url(#paint310_radial_578_447519)"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M47.172 33.6075C47.1057 33.721 47.0206 33.8155 46.9165 33.9196C46.8219 34.0141 46.7179 34.0898 46.6043 34.1749C46.3868 34.0236 46.1976 33.8439 46.0557 33.6264C46.1219 33.5129 46.207 33.4184 46.3111 33.3143C46.4057 33.2198 46.5098 33.1441 46.6233 33.059C46.7368 33.1252 46.8314 33.2103 46.9354 33.3143C47.0111 33.3994 47.0868 33.494 47.172 33.6075Z",
    fill: "url(#paint311_radial_578_447519)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M47.153 33.6075C47.0868 33.7115 47.0017 33.8155 46.9071 33.9101C46.8125 34.0047 46.7179 34.0804 46.6043 34.156C46.3868 34.0142 46.207 33.825 46.0557 33.6075C46.1219 33.5035 46.207 33.3994 46.3016 33.3049C46.3962 33.2103 46.4908 33.1346 46.6043 33.059C46.7084 33.1252 46.8125 33.2103 46.9071 33.3049C47.0017 33.3994 47.0868 33.5035 47.153 33.6075Z",
    fill: "url(#paint312_radial_578_447519)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1532 33.6073L46.6045 33.6168V33.0682C46.7086 33.1344 46.8126 33.2196 46.9072 33.3141C47.0018 33.4087 47.087 33.5033 47.1532 33.6073Z",
    fill: "url(#paint313_radial_578_447519)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6132 33.617V34.1465C46.3956 34.0047 46.2158 33.8155 46.0645 33.598L46.6132 33.617Z",
    fill: "url(#paint314_radial_578_447519)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6143 33.6168V33.0682C46.6143 33.0682 46.8981 33.229 47.163 33.6168C47.163 33.6168 46.8318 33.3047 46.6805 33.1912L46.6143 33.6168Z",
    fill: "url(#paint315_radial_578_447519)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0646 33.6072C46.0551 33.6166 46.6133 33.6166 46.6133 33.6166V34.1462L46.5565 33.6545L46.0646 33.6072Z",
    fill: "url(#paint316_radial_578_447519)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1532 33.6072C47.087 33.7112 47.0018 33.8152 46.9072 33.9098C46.8126 34.0044 46.718 34.08 46.6045 34.1557V33.6261L47.1532 33.6072Z",
    fill: "url(#paint317_radial_578_447519)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6193 35.2153V35.5558L46.5853 37.6175L44.5703 35.5558V35.2153L46.5853 36.6528L48.6193 35.2153Z",
    fill: "url(#paint318_radial_578_447519)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6189 35.2153V35.5558L46.585 37.6175V36.6528L48.6189 35.2153Z",
    fill: "url(#paint319_radial_578_447519)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6193 35.2153V35.5558L46.5853 37.6175L44.5703 35.5558V35.2153L46.5853 36.6528L48.6193 35.2153Z",
    fill: "url(#paint320_radial_578_447519)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6193 35.2153V35.5558L46.5853 37.6175L44.5703 35.5558V35.2153L46.5853 36.6528L48.6193 35.2153Z",
    fill: "url(#paint321_linear_578_447519)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5852 36.6531C46.5852 36.6531 46.5473 37.1259 46.5852 37.6083C46.5852 37.6177 46.6608 37.1638 46.5852 36.6531Z",
    fill: "url(#paint322_radial_578_447519)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5703 35.215L46.5853 36.6524L48.6193 35.215L48.4301 35.0731L46.6043 36.4349L44.7595 35.0826L44.5703 35.215Z",
    fill: "url(#paint323_radial_578_447519)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5703 35.2153L46.6043 36.7568L48.6193 35.2153L46.6043 36.6339L44.5703 35.2153Z",
    fill: "url(#paint324_radial_578_447519)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9531 18.8363C44.1994 18.8457 44.5498 18.8647 44.7202 18.8741C44.8907 18.8836 45.0328 18.8836 45.137 18.8836C45.2601 18.8836 45.5158 18.8742 45.8946 18.8457C46.0367 18.8363 46.1409 18.8363 46.2166 18.8363V19.3003C46.0083 19.3098 45.8662 19.3382 45.7999 19.3761C45.7336 19.414 45.7052 19.4803 45.7052 19.575C45.7052 19.6223 45.7147 19.6792 45.7242 19.736C45.7336 19.8023 45.762 19.8686 45.7905 19.9538L46.9838 23.5812L48.1013 19.9633C48.1392 19.878 48.1582 19.8117 48.1676 19.7644C48.1771 19.717 48.1771 19.6697 48.1771 19.6128C48.1771 19.4992 48.1392 19.4235 48.054 19.3666C47.9688 19.3193 47.8267 19.2908 47.6373 19.2908V18.8268C47.8267 18.8363 47.9687 18.8457 48.0919 18.8552C48.215 18.8646 48.3097 18.8647 48.3949 18.8647C48.4612 18.8647 48.5465 18.8646 48.6506 18.8552C48.7548 18.8457 48.9632 18.8457 49.1526 18.8268V19.2908C48.9726 19.3098 48.8495 19.3382 48.7832 19.3856C48.7169 19.4329 48.6601 19.5182 48.6317 19.6413L47.3531 23.4106C47.2774 23.6379 47.23 23.8179 47.1353 24.0547C47.0501 24.3009 46.9838 24.4335 46.8985 24.6892L46.3208 24.6419L44.5687 19.8023L44.5592 19.7739C44.4456 19.4424 44.2467 19.2814 43.9626 19.2814L43.9531 18.8363Z",
    fill: "url(#paint325_radial_578_447519)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6875 18.9882C43.9432 18.9976 44.161 19.0166 44.341 19.026C44.5209 19.0355 44.663 19.0355 44.7672 19.0355C44.8998 19.0355 45.1555 19.026 45.5532 19.0071C45.7048 18.9976 45.809 18.9976 45.8847 18.9976V19.3102C45.6669 19.3196 45.5248 19.348 45.4585 19.3859C45.3922 19.4238 45.3638 19.4901 45.3638 19.5848C45.3638 19.6322 45.3733 19.6795 45.3828 19.7458C45.3922 19.8121 45.4207 19.8784 45.4491 19.9636L46.6897 23.5342L47.8547 19.9731C47.8925 19.8879 47.9115 19.8216 47.9209 19.7742C47.9304 19.7269 47.9304 19.6795 47.9304 19.6227C47.9304 19.509 47.8925 19.4333 47.7978 19.3859C47.7031 19.3386 47.5611 19.3102 47.3527 19.3102V18.9976C47.5516 19.0071 47.7031 19.0166 47.8262 19.026C47.9494 19.0355 48.0535 19.0355 48.1388 19.0355C48.2051 19.0355 48.2903 19.0355 48.404 19.026C48.5176 19.0166 48.8112 19.0165 49.0101 18.9976V19.3102C48.8207 19.3291 48.6976 19.3575 48.6218 19.4049C48.5555 19.4522 48.4987 19.5374 48.4608 19.6606L47.1917 23.3731C47.1159 23.591 47.0307 23.8183 46.9455 24.055C46.8507 24.2918 46.7655 24.538 46.6613 24.7938L46.131 24.7464L44.322 19.8216L44.3126 19.7932C44.1989 19.4712 43.9906 19.3007 43.697 19.3007L43.6875 18.9882Z",
    fill: "url(#paint326_radial_578_447519)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8486 18.9783C44.1043 18.9877 44.3222 19.0067 44.5021 19.0161C44.6821 19.0256 44.8241 19.0256 44.9283 19.0256C45.0609 19.0256 45.3166 19.0161 45.7144 18.9972C45.8659 18.9877 45.9701 18.9878 46.0459 18.9878V19.3003C45.828 19.3097 45.686 19.3382 45.6197 19.3666C45.5534 19.4045 45.525 19.4707 45.525 19.5654C45.525 19.6128 45.5345 19.6602 45.5439 19.717C45.5534 19.7738 45.5818 19.8401 45.6102 19.9254L46.8509 23.4201L48.0158 19.9348C48.0537 19.8496 48.0726 19.7833 48.0821 19.7359C48.0916 19.6886 48.0916 19.6412 48.0916 19.5939C48.0916 19.4897 48.0537 19.4139 47.959 19.3666C47.8643 19.3192 47.7222 19.3003 47.5138 19.3003V18.9878C47.7127 18.9972 47.8643 19.0067 47.9874 19.0161C48.1105 19.0256 48.2147 19.0256 48.2999 19.0256C48.3662 19.0256 48.4515 19.0256 48.5651 19.0161C48.6788 19.0067 48.8303 19.0067 49.0292 18.9878V19.3003C48.8397 19.3192 48.7166 19.3476 48.6409 19.395C48.5746 19.4423 48.5178 19.5181 48.4799 19.6412L47.2108 23.278C47.135 23.4958 47.0498 23.7232 46.9645 23.9505C46.8698 24.1777 46.7846 24.424 46.6804 24.6797L46.2921 24.6323L44.4832 19.8117L44.4737 19.7833C44.3601 19.4708 44.1517 19.3098 43.8581 19.3098L43.8486 18.9783Z",
    fill: "url(#paint327_radial_578_447519)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7563 23.1831L45.6008 19.9156C45.5724 19.8304 45.5535 19.7641 45.5345 19.7073C45.5251 19.6504 45.5156 19.5936 45.5156 19.5558C45.5156 19.4989 45.525 19.4516 45.5535 19.4137C45.4966 19.4232 45.4588 19.4421 45.4209 19.4516C45.3546 19.4895 45.3262 19.5558 45.3262 19.6505C45.3262 19.6978 45.3356 19.7451 45.3451 19.802C45.3546 19.8588 45.383 19.9251 45.4114 20.0103L46.6521 23.5051L46.7563 23.1831Z",
    fill: "url(#paint328_radial_578_447519)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3127 19.1019C44.4927 19.1114 44.6347 19.1114 44.7389 19.1114C44.8715 19.1114 45.1272 19.102 45.525 19.083C45.6765 19.0736 45.7807 19.0735 45.8564 19.0735V19.3008C45.9133 19.2914 45.9796 19.2914 46.0459 19.2914V18.9788C45.9701 18.9788 45.8564 18.9883 45.7144 18.9883C45.3261 19.0073 45.0609 19.0167 44.9283 19.0167C44.8241 19.0167 44.6821 19.0072 44.5021 19.0072C44.3222 19.0072 44.1043 18.9883 43.8486 18.9694V19.0735C44.0286 19.0925 44.1801 19.0925 44.3127 19.1019Z",
    fill: "url(#paint329_radial_578_447519)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5561 19.007C48.4425 19.0165 48.3573 19.0165 48.291 19.0165C48.2057 19.0165 48.1015 19.0165 47.9784 19.007C47.8553 18.9975 47.6943 18.9975 47.5049 18.9786V19.0828C47.6185 19.0923 47.7038 19.0922 47.789 19.0922C47.9121 19.1017 48.0163 19.1017 48.1015 19.1017C48.1678 19.1017 48.2531 19.1017 48.3667 19.0922C48.4804 19.0827 48.6319 19.0828 48.8308 19.0638V19.3101C48.8876 19.3006 48.9539 19.2911 49.0202 19.2816V18.9691C48.8213 18.9881 48.6698 18.9975 48.5561 19.007Z",
    fill: "url(#paint330_radial_578_447519)"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4417 19.4708C48.3754 19.5182 48.3186 19.5939 48.2807 19.7171L47.0116 23.3538C46.9359 23.5717 46.8506 23.799 46.7654 24.0263C46.6896 24.2252 46.6139 24.4335 46.5381 24.6419L46.6896 24.6514C46.7843 24.3957 46.879 24.1589 46.9737 23.9221C47.0684 23.6948 47.1442 23.4675 47.22 23.2497L48.4891 19.6129C48.5175 19.5182 48.5554 19.4519 48.6122 19.4045C48.5269 19.433 48.4796 19.4519 48.4417 19.4708Z",
    fill: "url(#paint331_radial_578_447519)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5752 39.4696) scale(14.7489 14.7443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#006CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0818748,
    stopColor: "#026AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2005,
    stopColor: "#0663DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3416,
    stopColor: "#0D58BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4987,
    stopColor: "#174A94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5333,
    stopColor: "#194689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5338,
    stopColor: "#194689"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5927,
    stopColor: "#1152AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6548,
    stopColor: "#0B5BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7219,
    stopColor: "#0663DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7953,
    stopColor: "#0368ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8796,
    stopColor: "#016BF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006CF9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8019 40.2494) scale(22.5313 22.5241)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#39A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9987,
    stopColor: "#006CCE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4359 35.1592) rotate(180) scale(4.86469 4.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FF70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.588 37.8821) rotate(180) scale(2.49321 2.48922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.2383 35.3247) rotate(180) scale(2.43235 2.42845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.9865 36.4225) rotate(180) scale(3.28019 3.27493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.8996 38.3753) rotate(180) scale(1.97609 1.97292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.9971 36.2197) rotate(180) scale(2.26717 2.26353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.225 36.3423) rotate(180) scale(3.39005 3.38462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0643 39.6828) rotate(180) scale(3.46982 3.46427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.7436 35.3014) rotate(180) scale(2.08691 2.08357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4053 36.501) rotate(180) scale(4.71545 4.7079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4134 35.3217) rotate(180) scale(3.06721 3.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4125 38.7635) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4125 38.7634) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6552 36.3911) rotate(180) scale(2.15883 2.15538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4706 37.9742) rotate(180) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.548 37.1382) rotate(-90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.3255 37.0533) rotate(90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.3855 36.2165) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.14 37.6708) rotate(180) scale(4.86469 4.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FF70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2921 40.3937) rotate(180) scale(2.49321 2.48922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9424 37.8363) rotate(180) scale(2.43235 2.42845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6906 38.9341) rotate(180) scale(3.28019 3.27493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.6037 40.8869) rotate(180) scale(1.97609 1.97292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7013 38.7313) rotate(180) scale(2.26717 2.26353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9291 38.8539) rotate(180) scale(3.39005 3.38462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7684 42.1944) rotate(180) scale(3.46982 3.46427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.4477 37.813) rotate(180) scale(2.08691 2.08357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1094 39.0126) rotate(180) scale(4.71545 4.7079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1175 37.8333) rotate(180) scale(3.06721 3.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1166 41.275) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1166 41.275) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3593 38.9027) rotate(180) scale(2.15883 2.15538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.1747 40.4858) rotate(180) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2521 39.6498) rotate(-90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.0296 39.5649) rotate(90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.0896 38.7281) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8441 39.6104) rotate(180) scale(4.86469 4.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FF70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9962 42.3333) rotate(180) scale(2.49321 2.48922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.6465 39.7759) rotate(180) scale(2.43235 2.42845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.3947 40.8737) rotate(180) scale(3.28019 3.27493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.3078 42.8265) rotate(180) scale(1.97609 1.97292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.4054 40.6708) rotate(180) scale(2.26717 2.26353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.6332 40.7934) rotate(180) scale(3.39005 3.38462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4725 44.134) rotate(180) scale(3.46982 3.46427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.1518 39.7526) rotate(180) scale(2.08691 2.08357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8135 40.9521) rotate(180) scale(4.71545 4.7079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8216 39.7728) rotate(180) scale(3.06721 3.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8207 43.2146) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8207 43.2146) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0634 40.8423) rotate(180) scale(2.15883 2.15538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8788 42.4254) rotate(180) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.9562 41.5894) rotate(-90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.7337 41.5044) rotate(90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7937 40.6677) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5473 37.6708) rotate(180) scale(4.86469 4.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FF70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6993 40.3937) rotate(180) scale(2.49321 2.48922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3496 37.8363) rotate(180) scale(2.43235 2.42845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0978 38.9341) rotate(180) scale(3.28019 3.27493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0109 40.8869) rotate(180) scale(1.97609 1.97292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1085 38.7313) rotate(180) scale(2.26717 2.26353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3363 38.8539) rotate(180) scale(3.39005 3.38462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1757 42.1944) rotate(180) scale(3.46982 3.46427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.855 37.813) rotate(180) scale(2.08691 2.08357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5166 39.0126) rotate(180) scale(4.71545 4.7079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5247 37.8333) rotate(180) scale(3.06721 3.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5238 41.275) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5238 41.275) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.7666 38.9027) rotate(180) scale(2.15883 2.15538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5819 40.4858) rotate(180) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.6594 39.6498) rotate(-90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4368 39.5649) rotate(90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.4968 38.7281) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2904 35.1592) rotate(180) scale(4.86469 4.8569)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#FF70FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA8DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4425 37.8821) rotate(180) scale(2.49321 2.48922)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0928 35.3247) rotate(180) scale(2.43235 2.42845)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.841 36.4225) rotate(180) scale(3.28019 3.27493)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7541 38.3753) rotate(180) scale(1.97609 1.97292)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8516 36.2197) rotate(180) scale(2.26717 2.26353)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0795 36.3423) rotate(180) scale(3.39005 3.38462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9188 39.6828) rotate(180) scale(3.46982 3.46427)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5981 35.3014) rotate(180) scale(2.08691 2.08357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BC00CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2598 36.501) rotate(180) scale(4.71545 4.7079)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2679 35.3217) rotate(180) scale(3.06721 3.0623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#FEEEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.267 38.7635) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.267 38.7634) rotate(180) scale(2.71852 2.71417)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5097 36.3911) rotate(180) scale(2.15883 2.15538)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3251 37.9742) rotate(180) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4025 37.1382) rotate(-90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1799 37.0533) rotate(90) scale(1.87461 1.87762)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.24 36.2165) scale(1.87762 1.87461)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E05AFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3515 41.641) scale(5.8393 5.83744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.784 39.6344) scale(3.38826 3.38718)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.8263 39.5401) scale(2.77368 2.77283)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3756 57.5947) scale(35.2953 35.2843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3755 57.5939) scale(35.2953 35.2841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_578_447519",
    x1: 38.3073,
    y1: 26.4187,
    x2: 38.3073,
    y2: 38.2801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_578_447519",
    x1: 54.8644,
    y1: 26.418,
    x2: 54.8644,
    y2: 38.2793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004C72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04A1FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5513 11.3095) scale(14.7943 14.7895)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.5501 11.3092) scale(14.7943 14.7897)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.551 11.3097) scale(14.7943 14.7893)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.9691 13.8165) scale(16.7519 16.7466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.7858 5.28287) scale(23.9194 23.9117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0916 25.9412) scale(41.7163 41.703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(74.3979 14.8866) scale(10.1401 10.1369)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(68.5372 18.3788) scale(12.3035 12.2995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.5418 16.6102) scale(23.7523 23.7448)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(78.426 10.2044) scale(27.1934 27.1849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(73.2559 20.4232) scale(5.18953 5.18788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.3985 24.4265) scale(10.2752 10.2719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8468 37.2611) scale(30.9875 30.9775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(75.4543 25.1394) scale(32.6746 32.6643)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.8742 24.8337) scale(6.18394 6.18195)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.9716 26.2629) scale(5.51494 5.51322)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7955 33.7219) scale(21.3402 21.3335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.6711 31.4218) scale(16.0154 16.0104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.0386 30.5266) scale(4.61876 4.61732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1728 13.8166) rotate(180) scale(16.7519 16.7466)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint119_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3556 5.28311) rotate(180) scale(23.9194 23.9117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0504 25.9413) rotate(180) scale(41.7163 41.703)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint121_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.7438 14.8867) rotate(180) scale(10.1401 10.1368)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.604 18.3789) rotate(180) scale(12.3035 12.2995)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5996 16.6103) rotate(180) scale(23.7523 23.7448)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.716 10.2045) rotate(180) scale(27.1934 27.1849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.886 20.4234) rotate(180) scale(5.18952 5.18788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.7434 24.4268) rotate(180) scale(10.2752 10.2719)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2956 37.2611) rotate(180) scale(30.9874 30.9775)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.6879 25.1396) rotate(180) scale(32.6746 32.6644)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint129_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.2685 24.8337) rotate(180) scale(6.18392 6.18197)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1699 26.263) rotate(180) scale(5.51528 5.51357)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9FCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B6CCE0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.346 33.722) rotate(180) scale(21.3402 21.3335)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6893AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4703 31.4219) rotate(180) scale(16.0159 16.0109)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8D91A0",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1039 30.5267) rotate(180) scale(4.61876 4.61732)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9862 16.9107) scale(14.6017 18.3606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(66.8301 16.9854) scale(7.75651 9.75328)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(61.2461 18.1588) rotate(90) scale(15.2731 12.1462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8911 19.421) rotate(28.5566) scale(4.71602 5.43162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8665 15.8205) scale(3.18574 4.00581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(64.204 21.6602) scale(11.3365 14.2548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F99FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.3058 26.4073) rotate(-90) scale(5.96205 4.74144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.7656 18.5296) rotate(-90) scale(9.35291 7.43809)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.5087 21.3189) rotate(-28.4102) scale(7.76638 8.95387)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(69.0221 22.5993) rotate(-136.564) scale(2.69348 2.79843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.7828 14.5414) scale(14.482 14.4774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.0132 15.1601) scale(5.81837 5.81652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.4599 19.6581) scale(6.68546 6.68332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.0571 12.794) scale(7.18688 7.18458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5743 18.3964) scale(2.18027 2.17957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.8409 14.2341) scale(2.3462 2.34544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.6486 15.806) scale(4.27709 4.27576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.6916 27.839) scale(2.78135 2.78048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.9923 25.2417) scale(5.08042 5.0788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.1264 27.8034) scale(4.06276 4.0615)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8088 28.4899) scale(1.22053 1.22014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.924 29.9773) scale(3.70544 3.70429)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2414 16.9107) rotate(180) scale(14.6017 18.3606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3966 16.9856) rotate(180) scale(7.7565 9.75329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9815 18.1589) rotate(90) scale(15.2731 12.1462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2752 19.4617) rotate(151.444) scale(4.71604 5.43162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3613 15.8205) rotate(180) scale(3.18574 4.00581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0229 21.6602) rotate(180) scale(11.3365 14.2548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F99FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9215 26.4073) rotate(-90) scale(5.96205 4.74144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4611 18.5296) rotate(-90) scale(9.35291 7.43811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.722 21.3119) rotate(-151.59) scale(7.76649 8.95391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1354 22.5336) rotate(-43.4365) scale(2.69348 2.79843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3578 14.5414) rotate(180) scale(14.482 14.4774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.2414 16.9107) rotate(180) scale(14.6017 18.3606)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A61FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003370"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3966 16.9856) rotate(180) scale(7.7565 9.75329)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9815 18.1589) rotate(90) scale(15.2731 12.1462)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2752 19.4617) rotate(151.444) scale(4.71604 5.43162)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3613 15.8205) rotate(180) scale(3.18574 4.00581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.0229 21.6602) rotate(180) scale(11.3365 14.2548)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F99FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0050DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9215 26.4073) rotate(-90) scale(5.96205 4.74144)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.4611 18.5296) rotate(-90) scale(9.35291 7.43811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.722 21.3119) rotate(-151.59) scale(7.76649 8.95391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1354 22.5336) rotate(-43.4365) scale(2.69348 2.79843)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3578 14.5414) rotate(180) scale(14.482 14.4774)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C5EFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1276 15.1599) rotate(180) scale(5.81839 5.81652)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6809 19.658) rotate(180) scale(6.68546 6.68332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.084 12.7941) rotate(180) scale(7.18685 7.18458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5671 18.3964) rotate(180) scale(2.18029 2.17957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3005 14.2341) rotate(180) scale(2.34615 2.34544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4927 15.8062) rotate(180) scale(4.27709 4.27576)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4491 27.8389) rotate(180) scale(2.78135 2.78048)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.1481 25.2417) rotate(180) scale(5.08039 5.0788)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0142 27.8033) rotate(180) scale(4.06276 4.06147)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3319 28.4896) rotate(180) scale(1.22053 1.22014)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2164 29.9772) rotate(180) scale(3.70549 3.7043)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4141 25.0171) rotate(-166.604) scale(3.03227 3.03133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.812 22.4392) rotate(-166.604) scale(5.53873 5.537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.9008 24.6168) rotate(-166.604) scale(4.42929 4.42789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0651 25.425) rotate(-166.604) scale(1.33064 1.33022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6872 27.4785) rotate(-166.604) scale(4.03979 4.03849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6335 21.1316) rotate(-166.604) scale(7.2354 5.23343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5356 16.7975) rotate(-166.604) scale(13.2161 9.55933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.0176 20.2016) rotate(-166.604) scale(10.5689 7.64452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5223 21.6499) rotate(-166.604) scale(3.17508 2.29655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6421 25.5091) rotate(-166.604) scale(9.63946 6.97224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(59.5472 21.1316) rotate(-13.3964) scale(7.2354 5.23343)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.6451 16.7975) rotate(-13.3964) scale(13.2161 9.55933)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.163 20.2016) rotate(-13.3964) scale(10.5689 7.64452)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.6584 21.6499) rotate(-13.3964) scale(3.17508 2.29655)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5386 25.5091) rotate(-13.3964) scale(9.63946 6.97224)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.8007 25.0171) rotate(-13.3964) scale(3.03227 3.03133)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A4FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5257,
    stopColor: "#D7E5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CEFD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.4029 22.4392) rotate(-13.3964) scale(5.53873 5.537)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.3141 24.6168) rotate(-13.3964) scale(4.42929 4.42789)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(60.1497 25.425) rotate(-13.3964) scale(1.33064 1.33022)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(58.5276 27.4785) rotate(-13.3964) scale(4.03979 4.03849)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.3853 13.5044) scale(25.6763 25.6682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCD7EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#90A4DC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5901 11.7349) scale(12.9129 12.9088)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00074467,
    stopColor: "#F8FDFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3E6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.9592 40.63) scale(23.7221 23.7146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(57.0489 12.8791) scale(16.3939 16.3887)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint213_linear_578_447519",
    x1: 46.579,
    y1: 31.5266,
    x2: 46.579,
    y2: 12.2696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3AEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2671,
    stopColor: "#8D96A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7525,
    stopColor: "#68707C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A616B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5786 21.6103) scale(13.8524 13.848)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A3AEC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1649,
    stopColor: "#8A93A3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    stopColor: "#676E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6577,
    stopColor: "#4E535B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8578,
    stopColor: "#3E4349"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393D42"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4845 29.8807) scale(20.1329 20.1265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7522 12.9743) rotate(180) scale(20.1329 20.1265)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6493 20.5863) scale(15.4302 15.4254)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B5E7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5366 11.1138) scale(26.1059 26.0976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00276965,
    stopColor: "#04A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4517 25.7432) scale(13.3796 13.3754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2314 12.0016) scale(13.053 13.0489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.2164 17.9001) scale(17.6028 17.5973)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.0468 28.3931) scale(10.6045 10.6011)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5255 16.8113) scale(12.1665 12.1627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9336 17.4724) scale(18.1924 18.1867)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.8967 35.4198) scale(18.6205 18.6146)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.8841 11.8769) scale(11.1992 11.1957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7009 18.3208) scale(25.3051 25.2972)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#D2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6583 11.9869) scale(16.46 16.4547)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00499059,
    stopColor: "#D2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6623 30.4794) scale(14.5887 14.5841)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.7245 17.7349) scale(11.5852 11.5815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.351 26.2365) scale(10.0761 10.0729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.2931 21.7371) rotate(-90) scale(10.0729 10.0761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.7542 21.2956) rotate(90) scale(10.0729 10.0761)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7927 16.7969) rotate(180) scale(10.0761 10.0729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4898 29.0298) rotate(12.436) scale(2.502 2.5013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3497,
    stopColor: "#DBE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5842,
    stopColor: "#D2D7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#C3CAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9655,
    stopColor: "#AEB7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.6985 29.0935) rotate(12.436) scale(2.18043 2.17983)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.6796 33.8803) rotate(12.436) scale(5.97499 5.97332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8215 33.5143) rotate(12.4359) scale(4.25512 4.25393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.4933 29.6279) rotate(12.4361) scale(1.97527 1.97474)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.5074 29.8109) scale(0.0354811)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.3671 30.5651) rotate(12.4359) scale(3.70073 3.69967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2062,
    stopColor: "#C8CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4423,
    stopColor: "#B7BEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    stopColor: "#ACB5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.9961 32.7459) rotate(12.4359) scale(5.28039 5.27889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint243_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.9754 34.3935) rotate(12.4359) scale(5.57822 5.57664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.9421 31.1418) rotate(12.4353) scale(1.75156 1.75098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.968 28.3812) rotate(9.86072) scale(4.70283 4.70141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    stopColor: "#CDD2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8466,
    stopColor: "#B7BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint246_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.1365 33.998) rotate(9.86066) scale(5.83724 5.83545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint247_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.9837 33.6841) rotate(9.86066) scale(3.1204 3.11944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(53.2197 29.6015) rotate(9.86054) scale(1.99441 1.99377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.7936 30.1798) rotate(9.86069) scale(1.49002 1.48957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.0056 31.2009) rotate(12.4357) scale(4.83843 4.83698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3199,
    stopColor: "#C8CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7362,
    stopColor: "#B1BAE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0409 35.0261) rotate(12.4358) scale(7.92146 7.91912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.9611 34.5591) rotate(12.4358) scale(6.91272 6.91068)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(54.2002 32.0905) rotate(12.436) scale(2.64531 2.64458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.6542 29.2174) rotate(7.47297) scale(6.64693 6.64489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.3752 34.6318) rotate(12.4359) scale(4.65713 4.65581)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(49.6092 35.1217) rotate(12.4359) scale(4.01869 4.01754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.3675 30.1367) rotate(12.436) scale(1.89175 1.89123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(55.1593 32.371) rotate(12.4357) scale(5.78491 5.78317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.8767 31.4699) rotate(12.4357) scale(5.72026 5.71856)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.935 35.2499) rotate(12.4357) scale(3.71931 3.7182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(52.3819 33.2411) rotate(12.4358) scale(2.03687 2.03627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(51.0914 33.8667) rotate(12.4359) scale(5.41565 5.41412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.779 31.8003) rotate(12.4359) scale(5.58732 5.58574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3553 34.0647) rotate(12.4359) scale(8.0267 8.02443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.4775 34.661) rotate(12.4359) scale(4.35036 4.34911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.7014 29.0516) rotate(167.564) scale(2.502 2.5013)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3497,
    stopColor: "#DBE0FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5842,
    stopColor: "#D2D7F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7849,
    stopColor: "#C3CAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9655,
    stopColor: "#AEB7DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.4916 29.1152) rotate(167.564) scale(2.18046 2.17982)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.5104 33.902) rotate(167.564) scale(5.97499 5.97332)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3691 33.536) rotate(167.564) scale(4.25512 4.25393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6964 29.6498) rotate(167.564) scale(1.97522 1.97473)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6507 29.8108) scale(0.0354834 0.0354818)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8237 30.5869) rotate(167.564) scale(3.70073 3.69967)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2062,
    stopColor: "#C8CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4423,
    stopColor: "#B7BEE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6968,
    stopColor: "#ACB5DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.1952 32.7677) rotate(167.564) scale(5.28039 5.27889)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2159 34.4153) rotate(167.564) scale(5.57822 5.57664)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint275_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.249 31.1636) rotate(167.565) scale(1.75156 1.75098)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint276_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.2636 28.3908) rotate(170.139) scale(4.70283 4.70141)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2656,
    stopColor: "#DADEF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5518,
    stopColor: "#CDD2F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8466,
    stopColor: "#B7BFE4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint277_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0948 34.0075) rotate(170.139) scale(5.83719 5.83545)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint278_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.2477 33.6936) rotate(170.139) scale(3.12037 3.11944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint279_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.0114 29.6111) rotate(170.139) scale(1.99441 1.99377)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.4388 30.1895) rotate(170.139) scale(1.48999 1.48957)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1864 31.2226) rotate(167.564) scale(4.83843 4.83698)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3199,
    stopColor: "#C8CEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7362,
    stopColor: "#B1BAE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.1509 35.0477) rotate(167.564) scale(7.92145 7.91912)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.2306 34.5808) rotate(167.564) scale(6.91271 6.91068)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.9911 32.1122) rotate(167.564) scale(2.6453 2.64458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.5119 29.2091) rotate(172.527) scale(6.64693 6.64489)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.8154 34.6536) rotate(167.564) scale(4.65709 4.6558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5815 35.1434) rotate(167.564) scale(4.01868 4.01754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.8239 30.1584) rotate(167.564) scale(1.89175 1.89123)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.0314 32.3927) rotate(167.564) scale(5.7849 5.78317)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.3132 31.4916) rotate(167.564) scale(5.72025 5.71859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.2549 35.2716) rotate(167.564) scale(3.7193 3.71822)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.8099 33.2628) rotate(167.564) scale(2.03687 2.03627)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.0997 33.8884) rotate(167.564) scale(5.41565 5.41412)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.4119 31.822) rotate(167.564) scale(5.58732 5.58574)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint295_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8356 34.0864) rotate(167.564) scale(8.0267 8.02443)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.7131 34.6827) rotate(167.564) scale(4.35034 4.34911)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F8F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#88A4E2",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint297_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.4958 36.0106) scale(1.99656 1.99595)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCEFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#00AAFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint298_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6255 36.4965) scale(2.14303 2.09951)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint299_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.3687 35.3195) scale(2.58024 2.57945)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00AEFD",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint300_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6402 36.3036) scale(5.99531 5.99341)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint301_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.3423 36.3143) scale(1.51968 1.51921)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint302_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.561 36.0441) scale(0.618376 0.618384)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DCF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint303_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5218 32.7853) scale(7.29681 7.29451)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3F5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint304_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7138 33.7835) scale(3.63349 3.63234)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint305_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.585 33.3001) scale(3.66995 3.66994)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint306_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.7754 34.6755) scale(2.26522 2.26453)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.3457 35.5002) scale(4.37556 4.37419)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint308_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7806 35.0816) scale(1.87822 1.87763)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint309_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6043 34.1852) scale(1.14945 1.11289)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint310_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6043 32.5055) scale(1.9413 1.94074)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint311_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5997 33.6048) scale(0.486444 0.486309)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A829E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5988 33.2947) scale(1.16846 1.16812)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#04A1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint313_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4735 33.4877) scale(0.998886 0.998602)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.0614 33.4314) scale(1.0898 1.08939)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint315_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.6935 33.1207) scale(0.77058 0.77036)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00222094,
    stopColor: "#DCF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint316_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.654 33.6064) scale(0.613816 0.613581)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00222094,
    stopColor: "#DCF5FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint317_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.4102 33.4617) scale(0.865603 0.865296)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint318_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5446 35.8997) scale(4.03433 4.03303)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint319_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.6597 37.7837) scale(5.10032 5.09868)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#595D70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DEE2FC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint320_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.2576 34.6331) scale(4.5877 4.58622)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D666FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EA6C6",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint321_linear_578_447519",
    x1: 46.5832,
    y1: 38.4655,
    x2: 46.5832,
    y2: 35.8892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint322_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5723 36.9953) scale(0.697041 0.697047)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AEE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint323_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5437 36.0603) scale(5.12095 5.11921)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEE2FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9B2DB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint324_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.5437 36.1816) scale(5.11215 5.11045)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E5E9F9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint325_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7731 19.6581) scale(12.9425 12.9425)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0073AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint326_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.2391 22.4173) scale(15.2661 15.266)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.102,
    stopColor: "#E5F8FF",
    stopOpacity: 0.898
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2324,
    stopColor: "#D6F6FF",
    stopOpacity: 0.7676
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3783,
    stopColor: "#BBF2FF",
    stopOpacity: 0.6217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5355,
    stopColor: "#97EDFF",
    stopOpacity: 0.4645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7018,
    stopColor: "#67E7FF",
    stopOpacity: 0.2982
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.873,
    stopColor: "#2FDFFF",
    stopOpacity: 0.127
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint327_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.7484 21.8363) scale(6.27979 6.27977)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A5FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5339,
    stopColor: "#0C478E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0075F4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint328_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.5773 21.1691) scale(9.70124 9.70127)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1402,
    stopColor: "#003346",
    stopOpacity: 0.8598
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2859,
    stopColor: "#003E53",
    stopOpacity: 0.7141
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4341,
    stopColor: "#005067",
    stopOpacity: 0.5659
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5841,
    stopColor: "#006B85",
    stopOpacity: 0.4159
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7355,
    stopColor: "#008CAA",
    stopOpacity: 0.2645
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8858,
    stopColor: "#00B5D7",
    stopOpacity: 0.1142
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint329_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.0688 18.8609) scale(6.66299 6.663)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint330_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(48.0774 18.6276) scale(14.1725 14.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint331_radial_578_447519",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(47.5894 21.4872) scale(8.41094 8.41096)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#002F42"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D8FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.fd2cb835dc072281c0b6fb50e5cee41e.svg";
export { ForwardRef as ReactComponent };